import { MediaMatcher } from '@angular/cdk/layout';
import { Location } from '@angular/common';
import { ChangeDetectorRef, Component, HostListener, ViewChild, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NavigationEnd, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Observable, Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { Constant } from 'src/app/constant/constant';
import { EcryptServiceService } from 'src/app/core/auth/EcryptionService/ecrypt-service.service';
import { AccessSetService } from 'src/app/services/access-set.service';
import { AttributesetService } from 'src/app/services/attributeset.service';
import { CommonService } from 'src/app/services/common.service';
import { ConfigService } from 'src/app/services/config.service';
import { DeliveryPeopleService } from 'src/app/services/delivery-people.service';
import { DynamicFormGroupService } from 'src/app/services/dynamic-form-group.service';
import { ProductService } from 'src/app/services/product.service';
import { ScreenSizeService } from 'src/app/services/screen-size.service';
import { UsersService } from 'src/app/services/users.service';
import { RestrictionComponent } from 'src/app/shared/restriction-pop-up/restriction/restriction.component';
import { ScrollbarComponent } from 'src/app/shared/scrollbar/scrollbar.component';
import { TextEditorComponent } from 'src/app/shared/text-editor/text-editor.component';
import { trimValidator } from 'src/app/shared/utils/calsoft-validators';
import { environment } from 'src/environments/environment';
import { Clipboard } from '@angular/cdk/clipboard'
import { WhatappIntegrationPopupComponent } from 'src/app/whatapp-integration-popup/whatapp-integration-popup.component';
import { AccountsService } from 'src/app/services/accounts.service';
import { TourService } from 'src/app/modules/tour/services/tour.service';
@UntilDestroy()

@Component({
    selector: 'calsoft-dashboard-popup',
    templateUrl: './dashboard-popup.component.html',
    styleUrls: ['./dashboard-popup.component.scss']
})
export class DashboardPopupComponent implements OnDestroy {

    url = '';
    sanitizedUrl = '';

    @ViewChild(ScrollbarComponent, { static: true }) scrollbar: ScrollbarComponent;
    public serverPath = environment.commonImageApi + "logo/";
    logoVisible: any = true;
    logoBGVisible: any = true;
    bigLogoVisible: any = true;
    mobileQuery = this.mediaMatcher.matchMedia('(max-width: 959px)');
    drawerOpen$ = this.screenSizeService.drawerOpen$;
    drawerOpen = true;
    drawerMode = 'side';
    drawerDisableClose = true;
    chats: any[];
    activeChat: any;
    newMessage: string;
    text: string;
    pageIndex = 0;
    menu: any;
    logoUpload: boolean;
    firstFormGroup: UntypedFormGroup;

    countryList: any;
    filteredcountryTypeList: any;
    countryTypeList: any;
    countryControl: UntypedFormControl = new UntypedFormControl();
    countryFilterControl: UntypedFormControl = new UntypedFormControl();
    protected _onDestroy = new Subject<void>();
    protected _onDestroy1 = new Subject<void>();
    options: any;

    public sortings = [
        { value: "price,DESC", viewValue: "Price - High to Low" },
        { value: "price,ASC", viewValue: "Price - Low to High" },
        { value: "createdDate,DESC", viewValue: "Newest First" },
    ];
    filterMap = new Map<any, any>();
    paths: any = [];
    sortParam: string = this.sortings[0].value;
    public sort: string = this.sortings[0].viewValue;
    lastValueChanged: any;
    indexFilter: any;
    condition: string;
    filterPaginate: any = false;
    updatedRange: any;
    filterCategoryId: any;


    public viewCol: number = 25;
    selectLayout: any;
    selectLayoutValue: any;
    highlighted: any;
    allCountryList: any;
    resourcePrivilege: any;
    imageSrc: string;
    waBotRestriction: any = false;
    gaRestriction: boolean = false;
    pixelRestriction: boolean = false;
    storePickupRestriction: boolean = false;
    posRestriction: boolean = false;
    languageRestriction: boolean = false;
    updateStockByPurchase: boolean = false;
    removeExpiryFromStock: boolean = false;
    enableCashInHandRestriction: boolean = false;
    basedOnVendorRestriction: boolean = false;
    chatbotRestriction: boolean = false;
    seoRestriction: boolean = false;
    pincodeRestriction: boolean = false;
    firstIndex: any = 0;
    secondIndex: any = 0;

    firstDropDownValue = new UntypedFormControl(1);
    secondDropDownValue = new UntypedFormControl(1);
    colourCode: any;
    partialPaymentRestriction: boolean = false;
    socialLoginRestriction: boolean = false;
    discountSpinnerRestriction: boolean = false;
    googleMapRestriction: boolean = false;
    generalRestriction: boolean = false;
    paymentRestriction: boolean = false;
    partnerRestriction: boolean = false;
    path2: string;
    path3: string;
    path5: string;
    path6: string;
    secondaryLogoVisible: boolean = true;
    secondaryBackgroundVisible: boolean = true;
    path8: string;
    path9: string;
    accessList: any;
    userList: any;
    userName: string;
    whatsappCreated: any = 1;
    formSubmitted: any = 0;

    constructor(
        private location: Location,
        private ecryptService: EcryptServiceService,
        private formBuilder: UntypedFormBuilder,
        private configService: ConfigService,
        private snackBar: MatSnackBar,
        private commonService: CommonService,
        private router: Router,
        private cd: ChangeDetectorRef,
        private screenSizeService: ScreenSizeService,
        private mediaMatcher: MediaMatcher,
        private dialog: MatDialog,
        private productService: ProductService,
        private dynamicFormGroupService: DynamicFormGroupService,
        private attributeService: AttributesetService,
        private usersService: UsersService,
        private accessSetService: AccessSetService,
        private encryptedService: EcryptServiceService,
        private clipboard: Clipboard,
        private _changeDetectorRef: ChangeDetectorRef,
        private accountService: AccountsService,
        private tourService: TourService,
        private dialogRef: MatDialogRef<DashboardPopupComponent>

    ) {
        this.url = this.router.url || '';
        this.sanitizedUrl = this.sanitizeUrl(this.url);
        this.router.events.pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy)).subscribe(() => {
            this.url = this.router.url || '';
            this.sanitizedUrl = this.sanitizeUrl(this.url);
        });

        this.url = this.router.url || '';
        this.router.events
            .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
            .subscribe(() => { this.url = this.router.url || ''; });
    }

    private _mobileQueryListener: () => void;

    ngOnDestroy(): void {
        this.mobileQuery.removeEventListener('change', this._mobileQueryListener);
        this._onDestroy.next();
        this._onDestroy.complete();
    }


    currencycode: any = [{
        "country": "Afghanistan",
        "currencycode": "AFN",
        "displayname": "afn"
    },
    {
        "country": "Albania",
        "currencycode": "ALL",
        "displayname": "all"
    },
    {
        "country": "Algeria",
        "currencycode": "DZD",
        "displayname": "dzd"
    },

    {
        "country": "Andorra",
        "currencycode": "EUR",
        "displayname": "eur"
    },
    {
        "country": "Angola",
        "currencycode": "AOA",
        "displayname": "aoa"
    },
    {
        "country": "Anguilla",
        "currencycode": "XCD",
        "displayname": "xcd"
    },
    {
        "country": "Antarctica",
        "currencycode": "XCD",
        "displayname": "xcd"
    },
    {
        "country": "Antigua and Barbuda",
        "currencycode": "XCD",
        "displayname": "xcd"
    },
    {
        "country": "Argentina",
        "currencycode": "ARS",
        "displayname": "ars"
    },
    {
        "country": "Armenia",
        "currencycode": "AMD",
        "displayname": "amd"
    },
    {
        "country": "Aruba",
        "currencycode": "AWG",
        "displayname": "awg"
    },
    {
        "country": "Australia",
        "currencycode": "AUD",
        "displayname": "aud"
    },
    {
        "country": "Austria",
        "currencycode": "EUR",
        "displayname": "eur"
    },
    {
        "country": "Azerbaijan",
        "currencycode": "AZN",
        "displayname": "azn"
    },
    {
        "country": "Bahamas",
        "currencycode": "BSD",
        "displayname": "bsd"
    },
    {
        "country": "Bahrain",
        "currencycode": "BHD",
        "displayname": "bhd"
    },
    {
        "country": "Bangladesh",
        "currencycode": "BDT",
        "displayname": "bdt"
    },
    {
        "country": "Barbados",
        "currencycode": "BBD",
        "displayname": "bbd"
    },
    {
        "country": "Belarus",
        "currencycode": "BYR",
        "displayname": "byr"
    },
    {
        "country": "Belgium",
        "currencycode": "EUR",
        "displayname": "eur"
    },
    {
        "country": "Belize",
        "currencycode": "BZD",
        "displayname": "bzd"
    },
    {
        "country": "Benin",
        "currencycode": "XOF",
        "displayname": "xof"
    },
    {
        "country": "Bermuda",
        "currencycode": "BMD",
        "displayname": "bmd"
    },
    {
        "country": "Bhutan",
        "currencycode": "BTN",
        "displayname": "btn"
    },
    {
        "country": "Bolivia",
        "currencycode": "BOB",
        "displayname": "bob"
    },
    {
        "country": "Bosnia and Herzegovina",
        "currencycode": "BAM",
        "displayname": "bam"
    },
    {
        "country": "Botswana",
        "currencycode": "BWP",
        "displayname": "bwp"
    },
    {
        "country": "Bouvet Island",
        "currencycode": "NOK",
        "displayname": "nok"
    },
    {
        "country": "Brazil",
        "currencycode": "BRL",
        "displayname": "brl"
    },

    {
        "country": "Brunei",
        "currencycode": "BND",
        "displayname": "bnd"
    },
    {
        "country": "Bulgaria",
        "currencycode": "BGN",
        "displayname": "bgn"
    },
    {
        "country": "Burkina Faso",
        "currencycode": "XOF",
        "displayname": "xof"
    },
    {
        "country": "Burundi",
        "currencycode": "BIF",
        "displayname": "bif"
    },
    {
        "country": "Cambodia",
        "currencycode": "KHR",
        "displayname": "khr"
    },
    {
        "country": "Cameroon",
        "currencycode": "XAF",
        "displayname": "xaf"
    },
    {
        "country": "Canada",
        "currencycode": "CAD",
        "displayname": "cad"
    },
    {
        "country": "Cape Verde",
        "currencycode": "CVE",
        "displayname": "cve"
    },
    {
        "country": "Cayman Islands",
        "currencycode": "KYD",
        "displayname": "kyd"
    },
    {
        "country": "Central African Republic",
        "currencycode": "XAF",
        "displayname": "xaf"
    },
    {
        "country": "Chad",
        "currencycode": "XAF",
        "displayname": "xaf"
    },
    {
        "country": "Chile",
        "currencycode": "CLP",
        "displayname": "clp"
    },
    {
        "country": "China",
        "currencycode": "CNY",
        "displayname": "cyn"
    },
    {
        "country": "Christmas Island",
        "currencycode": "AUD",
        "displayname": "aud"
    },
    {
        "country": "Cocos (Keeling) Islands",
        "currencycode": "AUD",
        "displayname": "aud"
    },
    {
        "country": "Colombia",
        "currencycode": "COP",
        "displayname": "cop"
    },
    {
        "country": "Comoros",
        "currencycode": "KMF",
        "displayname": "kmf"
    },
    {
        "country": "Congo",
        "currencycode": "XAF",
        "displayname": "xaf"
    },
    {
        "country": "Cook Islands",
        "currencycode": "NZD",
        "displayname": "nzd"
    },
    {
        "country": "Costa Rica",
        "currencycode": "CRC",
        "displayname": "crc"
    },
    {
        "country": "Croatia",
        "currencycode": "HRK",
        "displayname": "hrk"
    },
    {
        "country": "Cuba",
        "currencycode": "CUP",
        "displayname": "cup"
    },
    {
        "country": "Cyprus",
        "currencycode": "EUR",
        "displayname": "eur"
    },
    {
        "country": "Czech Republic",
        "currencycode": "CZK",
        "displayname": "czk"
    },
    {
        "country": "Denmark",
        "currencycode": "DKK",
        "displayname": "dkk"
    },
    {
        "country": "Djibouti",
        "currencycode": "DJF",
        "displayname": "djf"
    },
    {
        "country": "Dominica",
        "currencycode": "XCD",
        "displayname": "xcd"
    },
    {
        "country": "Dominican Republic",
        "currencycode": "DOP",
        "displayname": "dop"
    },

    {
        "country": "Ecuador",
        "currencycode": "ECS",
        "displayname": "ecs"
    },
    {
        "country": "Egypt",
        "currencycode": "EGP",
        "displayname": "egp"
    },
    {
        "country": "El Salvador",
        "currencycode": "SVC",
        "displayname": "svc"
    },
    {
        "country": "England",
        "currencycode": "GBP",
        "displayname": "gbp"
    },
    {
        "country": "Equatorial Guinea",
        "currencycode": "XAF",
        "displayname": "xaf"
    },
    {
        "country": "Eritrea",
        "currencycode": "ERN",
        "displayname": "ern"
    },
    {
        "country": "Estonia",
        "currencycode": "EUR",
        "displayname": "eur"
    },
    {
        "country": "Ethiopia",
        "currencycode": "ETB",
        "displayname": "etb"
    },
    {
        "country": "Falkland Islands",
        "currencycode": "FKP",
        "displayname": "fkp"
    },
    {
        "country": "Faroe Islands",
        "currencycode": "DKK",
        "displayname": "dkk"
    },
    {
        "country": "Fiji Islands",
        "currencycode": "FJD",
        "displayname": "fjp"
    },
    {
        "country": "Finland",
        "currencycode": "EUR",
        "displayname": "eur"
    },
    {
        "country": "France",
        "currencycode": "EUR",
        "displayname": "eur"
    },
    {
        "country": "French Guiana",
        "currencycode": "EUR",
        "displayname": "eur"
    },
    {
        "country": "French Polynesia",
        "currencycode": "XPF",
        "displayname": "xpf"
    },
    {
        "country": "French Southern territories",
        "currencycode": "EUR",
        "displayname": "eur"
    },
    {
        "country": "Gabon",
        "currencycode": "XAF",
        "displayname": "xaf"
    },
    {
        "country": "Gambia",
        "currencycode": "GMD",
        "displayname": "gmd"
    },
    {
        "country": "Georgia",
        "currencycode": "GEL",
        "displayname": "gel"
    },
    {
        "country": "Germany",
        "currencycode": "EUR",
        "displayname": "eur"
    },
    {
        "country": "Ghana",
        "currencycode": "GHS",
        "displayname": "ghs"
    },
    {
        "country": "Gibraltar",
        "currencycode": "GIP",
        "displayname": "gip"
    },
    {
        "country": "Greece",
        "currencycode": "EUR",
        "displayname": "eur"
    },
    {
        "country": "Greenland",
        "currencycode": "DKK",
        "displayname": "dkk"
    },
    {
        "country": "Grenada",
        "currencycode": "XCD",
        "displayname": "xcd"
    },
    {
        "country": "Guadeloupe",
        "currencycode": "EUR",
        "displayname": "eur"
    },

    {
        "country": "Guatemala",
        "currencycode": "QTQ",
        "displayname": "qtq"
    },
    {
        "country": "Guinea",
        "currencycode": "GNF",
        "displayname": "gnf"
    },
    {
        "country": "Guinea-Bissau",
        "currencycode": "CFA",
        "displayname": "cfa"
    },
    {
        "country": "Guyana",
        "currencycode": "GYD",
        "displayname": "gyd"
    },
    {
        "country": "Haiti",
        "currencycode": "HTG",
        "displayname": "htg"
    },
    {
        "country": "Heard Island and McDonald Islands",
        "currencycode": "AUD",
        "displayname": "aud"
    },
    {
        "country": "Holy See (Vatican City State)",
        "currencycode": "EUR",
        "displayname": "eur"
    },
    {
        "country": "Honduras",
        "currencycode": "HNL",
        "displayname": "hnl"
    },
    {
        "country": "Hong Kong",
        "currencycode": "HKD",
        "displayname": "hkd"
    },
    {
        "country": "Hungary",
        "currencycode": "HUF",
        "displayname": "huf"
    },
    {
        "country": "Iceland",
        "currencycode": "ISK",
        "displayname": "isk"
    },
    {
        "country": "India",
        "currencycode": "INR",
        "displayname": "inr"
    },
    {
        "country": "Indonesia",
        "currencycode": "IDR",
        "displayname": "idr"
    },
    {
        "country": "Iran",
        "currencycode": "IRR",
        "displayname": "irr"
    },
    {
        "country": "Iraq",
        "currencycode": "IQD",
        "displayname": "iqd"
    },
    {
        "country": "Ireland",
        "currencycode": "EUR",
        "displayname": "eur"
    },
    {
        "country": "Israel",
        "currencycode": "ILS",
        "displayname": "ils"
    },
    {
        "country": "Italy",
        "currencycode": "EUR",
        "displayname": "eur"
    },
    {
        "country": "Ivory Coast",
        "currencycode": "XOF",
        "displayname": "xof"
    },
    {
        "country": "Jamaica",
        "currencycode": "JMD",
        "displayname": "jmd"
    },
    {
        "country": "Japan",
        "currencycode": "JPY",
        "displayname": "jpy"
    },
    {
        "country": "Jordan",
        "currencycode": "JOD",
        "displayname": "jod"
    },
    {
        "country": "Kazakhstan",
        "currencycode": "KZT",
        "displayname": "kzt"
    },
    {
        "country": "Kenya",
        "currencycode": "KES",
        "displayname": "kes"
    },
    {
        "country": "Kiribati",
        "currencycode": "AUD",
        "displayname": "aud"
    },
    {
        "country": "Kuwait",
        "currencycode": "KWD",
        "displayname": "kwd"
    },
    {
        "country": "Kyrgyzstan",
        "currencycode": "KGS",
        "displayname": "kgs"
    },
    {
        "country": "Laos",
        "currencycode": "LAK",
        "displayname": "lak"
    },
    {
        "country": "Latvia",
        "currencycode": "LVL",
        "displayname": "lvl"
    },
    {
        "country": "Lebanon",
        "currencycode": "LBP",
        "displayname": "lbp"
    },
    {
        "country": "Lesotho",
        "currencycode": "LSL",
        "displayname": "lsl"
    },
    {
        "country": "Liberia",
        "currencycode": "LRD",
        "displayname": "lrd"
    },
    {
        "country": "Libyan Arab Jamahiriya",
        "currencycode": "LYD",
        "displayname": "lyd"
    },
    {
        "country": "Liechtenstein",
        "currencycode": "CHF",
        "displayname": "chf"
    },
    {
        "country": "Lithuania",
        "currencycode": "LTL",
        "displayname": "ltl"
    },
    {
        "country": "Luxembourg",
        "currencycode": "EUR",
        "displayname": "eur"
    },
    {
        "country": "Macao",
        "currencycode": "MOP",
        "displayname": "mop"
    },
    {
        "country": "North Macedonia",
        "currencycode": "MKD",
        "displayname": "mkd"
    },
    {
        "country": "Madagascar",
        "currencycode": "MGF",
        "displayname": "mgj"
    },
    {
        "country": "Malawi",
        "currencycode": "MWK",
        "displayname": "mwk"
    },
    {
        "country": "Malaysia",
        "currencycode": "MYR",
        "displayname": "myr"
    },
    {
        "country": "Maldives",
        "currencycode": "MVR",
        "displayname": "mvr"
    },
    {
        "country": "Mali",
        "currencycode": "XOF",
        "displayname": "xof"
    },
    {
        "country": "Malta",
        "currencycode": "EUR",
        "displayname": "eur"
    },

    {
        "country": "Martinique",
        "currencycode": "EUR",
        "displayname": "eur"
    },
    {
        "country": "Mauritania",
        "currencycode": "MRO",
        "displayname": "mro"
    },
    {
        "country": "Mauritius",
        "currencycode": "MUR",
        "displayname": "mur"
    },
    {
        "country": "Mayotte",
        "currencycode": "EUR",
        "displayname": "eur"
    },
    {
        "country": "Mexico",
        "currencycode": "MXN",
        "displayname": "mxn"
    },

    {
        "country": "Moldova",
        "currencycode": "MDL",
        "displayname": "mdl"
    },
    {
        "country": "Monaco",
        "currencycode": "EUR",
        "displayname": "eur"
    },
    {
        "country": "Mongolia",
        "currencycode": "MNT",
        "displayname": "mnt"
    },
    {
        "country": "Montserrat",
        "currencycode": "XCD",
        "displayname": "xcd"
    },
    {
        "country": "Morocco",
        "currencycode": "MAD",
        "displayname": "mad"
    },
    {
        "country": "Mozambique",
        "currencycode": "MZN",
        "displayname": "mzn"
    },
    {
        "country": "Myanmar",
        "currencycode": "MMR",
        "displayname": "mmr"
    },
    {
        "country": "Namibia",
        "currencycode": "NAD",
        "displayname": "nad"
    },
    {
        "country": "Nauru",
        "currencycode": "AUD",
        "displayname": "aud"
    },
    {
        "country": "Nepal",
        "currencycode": "NPR",
        "displayname": "npr"
    },
    {
        "country": "Netherlands",
        "currencycode": "EUR",
        "displayname": "eur"
    },
    {
        "country": "Netherlands Antilles",
        "currencycode": "ANG",
        "displayname": "ang"
    },
    {
        "country": "New Caledonia",
        "currencycode": "XPF",
        "displayname": "xpf"
    },
    {
        "country": "New Zealand",
        "currencycode": "NZD",
        "displayname": "nzd"
    },
    {
        "country": "Nicaragua",
        "currencycode": "NIO",
        "displayname": "nio"
    },
    {
        "country": "Niger",
        "currencycode": "XOF",
        "displayname": "xof"
    },
    {
        "country": "Nigeria",
        "currencycode": "NGN",
        "displayname": "ngn"
    },
    {
        "country": "Niue",
        "currencycode": "NZD",
        "displayname": "nzd"
    },
    {
        "country": "Norfolk Island",
        "currencycode": "AUD",
        "displayname": "aud"
    },
    {
        "country": "North Korea",
        "currencycode": "KPW",
        "displayname": "kpw"
    },
    {
        "country": "Northern Ireland",
        "currencycode": "GBP",
        "displayname": "gbp"
    },

    {
        "country": "Norway",
        "currencycode": "NOK",
        "displayname": "nok"
    },
    {
        "country": "Oman",
        "currencycode": "OMR",
        "displayname": "omr"
    },
    {
        "country": "Pakistan",
        "currencycode": "PKR",
        "displayname": "pkr"
    },

    {
        "country": "Palestine",
        "currencycode": "null",
        "displayname": "null"
    },
    {
        "country": "Panama",
        "currencycode": "PAB",
        "displayname": "pab"
    },
    {

        "country": "Papua New Guinea",
        "currencycode": "PGK",
        "displayname": "pgk"
    },
    {
        "country": "Paraguay",
        "currencycode": "PYG",
        "displayname": "pyg"
    },
    {
        "country": "Peru",
        "currencycode": "PEN",
        "displayname": "pen"
    },
    {
        "country": "Philippines",
        "currencycode": "PHP",
        "displayname": "php"
    },
    {
        "country": "Pitcairn",
        "currencycode": "NZD",
        "displayname": "nzd"
    },
    {
        "country": "Poland",
        "currencycode": "PLN",
        "displayname": "pln"
    },
    {
        "country": "Portugal",
        "currencycode": "EUR",
        "displayname": "eur"
    },

    {
        "country": "Qatar",
        "currencycode": "QAR",
        "displayname": "qar"
    },
    {
        "country": "Reunion",
        "currencycode": "EUR",
        "displayname": "eur"
    },
    {
        "country": "Romania",
        "currencycode": "RON",
        "displayname": "ron"
    },
    {
        "country": "Russian Federation",
        "currencycode": "RUB",
        "displayname": "rub"
    },
    {
        "country": "Rwanda",
        "currencycode": "RWF",
        "displayname": "rwf"
    },
    {
        "country": "Saint Helena",
        "currencycode": "SHP",
        "displayname": "shp"
    },
    {
        "country": "Saint Kitts and Nevis",
        "currencycode": "XCD",
        "displayname": "xcd"
    },
    {
        "country": "Saint Lucia",
        "currencycode": "XCD",
        "displayname": "xcd"
    },
    {
        "country": "Saint Pierre and Miquelon",
        "currencycode": "EUR",
        "displayname": "eur"
    },
    {
        "country": "Saint Vincent and the Grenadines",
        "currencycode": "XCD",
        "displayname": "xcd"
    },
    {
        "country": "Samoa",
        "currencycode": "WST",
        "displayname": "wst"
    },
    {
        "country": "San Marino",
        "currencycode": "EUR",
        "displayname": "eur"
    },
    {
        "country": "Sao Tome and Principe",
        "currencycode": "STD",
        "displayname": "std"
    },
    {
        "country": "Saudi Arabia",
        "currencycode": "SAR",
        "displayname": "sar"
    },
    {
        "country": "Scotland",
        "currencycode": "GBP",
        "displayname": "gbp"
    },
    {
        "country": "Senegal",
        "currencycode": "XOF",
        "displayname": "xof"
    },
    {
        "country": "Serbia",
        "currencycode": "RSD",
        "displayname": "rsd"
    },
    {
        "country": "Seychelles",
        "currencycode": "SCR",
        "displayname": "scr"
    },
    {
        "country": "Sierra Leone",
        "currencycode": "SLL",
        "displayname": "sll"
    },
    {
        "country": "Singapore",
        "currencycode": "SGD",
        "displayname": "sgd"
    },
    {
        "country": "Slovakia",
        "currencycode": "EUR",
        "displayname": "eur"
    },
    {
        "country": "Slovenia",
        "currencycode": "EUR",
        "displayname": "eur"
    },
    {
        "country": "Solomon Islands",
        "currencycode": "SBD",
        "displayname": "sbd"
    },
    {
        "country": "Somalia",
        "currencycode": "SOS",
        "displayname": "sos"
    },
    {
        "country": "South Africa",
        "currencycode": "ZAR",
        "displayname": "zar"
    },
    {
        "country": "South Georgia and the South Sandwich Islands",
        "currencycode": "GBP",
        "displayname": "gbp"
    },
    {
        "country": "South Korea",
        "currencycode": "KRW",
        "displayname": "krw"
    },
    {
        "country": "South Sudan",
        "currencycode": "SSP",
        "displayname": "ssp"
    },
    {
        "country": "Spain",
        "currencycode": "EUR",
        "displayname": "eur"
    },
    {
        "country": "Sri Lanka",
        "currencycode": "LKR",
        "displayname": "lkr"
    },
    {
        "country": "Sudan",
        "currencycode": "SDG",
        "displayname": "sdg"
    },
    {
        "country": "Suriname",
        "currencycode": "SRD",
        "displayname": "srd"
    },
    {
        "country": "Svalbard and Jan Mayen",
        "currencycode": "NOK",
        "displayname": "nok"
    },
    {
        "country": "Swaziland",
        "currencycode": "SZL",
        "displayname": "szl"
    },
    {
        "country": "Sweden",
        "currencycode": "SEK",
        "displayname": "sek"
    },
    {
        "country": "Switzerland",
        "currencycode": "CHF",
        "displayname": "chf"
    },
    {
        "country": "Syria",
        "currencycode": "SYP",
        "displayname": "syp"
    },
    {
        "country": "Tajikistan",
        "currencycode": "TJS",
        "displayname": "tjs"
    },
    {
        "country": "Tanzania",
        "currencycode": "TZS",
        "displayname": "tzs"
    },
    {
        "country": "Thailand",
        "currencycode": "THB",
        "displayname": "thb"
    },
    {
        "country": "The Democratic Republic of Congo",
        "currencycode": "CDF",
        "displayname": "cdf"
    },
    {
        "country": "Togo",
        "currencycode": "XOF",
        "displayname": "xof"
    },
    {
        "country": "Tokelau",
        "currencycode": "NZD",
        "displayname": "nzd"
    },
    {
        "country": "Tonga",
        "currencycode": "TOP",
        "displayname": "top"
    },
    {
        "country": "Trinidad and Tobago",
        "currencycode": "TTD",
        "displayname": "ttd"
    },
    {
        "country": "Tunisia",
        "currencycode": "TND",
        "displayname": "tnd"
    },
    {
        "country": "Turkey",
        "currencycode": "TRY",
        "displayname": "try"
    },
    {
        "country": "Turkmenistan",
        "currencycode": "TMT",
        "displayname": "tmt"
    },

    {
        "country": "Tuvalu",
        "currencycode": "AUD",
        "displayname": "aud"
    },
    {
        "country": "Uganda",
        "currencycode": "UGX",
        "displayname": "ugx"
    },
    {
        "country": "Ukraine",
        "currencycode": "UAH",
        "displayname": "uah"
    },
    {
        "country": "United Arab Emirates",
        "currencycode": "AED",
        "displayname": "aed"
    },
    {
        "country": "United Kingdom",
        "currencycode": "GBP",
        "displayname": "gbp"
    },
    {
        "country": "United States",
        "currencycode": "USD",
        "displayname": "usd"
    },

    {
        "country": "Uruguay",
        "currencycode": "UYU",
        "displayname": "uyu"
    },
    {
        "country": "Uzbekistan",
        "currencycode": "UZS",
        "displayname": "uzs"
    },
    {
        "country": "Vanuatu",
        "currencycode": "VUV",
        "displayname": "vuv"
    },
    {
        "country": "Venezuela",
        "currencycode": "VEF",
        "displayname": "vef"
    },
    {
        "country": "Vietnam",
        "currencycode": "VND",
        "displayname": "vnd"
    },


    {
        "country": "Wales",
        "currencycode": "GBP",
        "displayname": "gbp"
    },
    {
        "country": "Wallis and Futuna",
        "currencycode": "XPF",
        "displayname": "xpf"
    },
    {
        "country": "Western Sahara",
        "currencycode": "MAD",
        "displayname": "mad"
    },
    {
        "country": "Yemen",
        "currencycode": "YER",
        "displayname": "yer"
    },
    {
        "country": "Zambia",
        "currencycode": "ZMW",
        "displayname": "zmw"
    },
    {
        "country": "Zimbabwe",
        "currencycode": "ZWD",
        "displayname": "zwd"
    }


    ]

    generalForm() {
        this.firstFormGroup = this.formBuilder.group({
            configId: [''],
            siteName: ['',],
            storeName: ['', [Validators.required, trimValidator]],
            unsecureBaseUrl: ['',],
            baseUrl: ['',],
            currencyBase: ['', [Validators.required]],
            defaultTitle: [''],
            logoSrc: [''],
            logoWithoutBackgroundSrc: [''],
            name: ['', [Validators.required, trimValidator]],
            email: ['', [Validators.required]],
            supportName: [''],
            supportEmail: [''],
            smtpHost: [''],
            smtpPassword: [''],
            storePhoneNumber: [''],
            storeHoursOfOperation: [''],
            country: ['', [Validators.required, trimValidator]],
            regionState: [''],
            zipPostCode: ['', [Validators.required, trimValidator]],
            city: ['', [Validators.required, trimValidator]],
            streetAddress: ['', [Validators.required, trimValidator]],
            streetAddressLine2: [''],
            vatNumber: [''],
            ssl: [''],
            disableEmailCommunication: [''],
            smtpPort: [''],
            layout: [''],
            color: ['red'],
            ccAvenueAccessCode: [''],
            ccAvenueEncKey: [''],
            ccAvenueMerchantId: [''],
            ccAvenueUrl: [''],
            aromexUserName: [''],
            aromexPassword: [''],
            aromexVersion: [''],
            aromexAccountNumber: [''],
            aromexAccountPin: [''],
            aromexAccountEntity: [''],
            aromexAccountCountryCode: [''],
            aromexSource: [''],
            orderPrefix: ['', [Validators.required]],
            AdminMenuType: [1],
            customButtonInCategroyPageNavigation: [''],
            leftMenuColor: ['white'],
            leftMenuHoverColor: ['#131822'],
            leftMenuBgColor: ['#011838'],
            mainfontcolor: [''],
            mainBgColor: [''],
            headerBgColor: [''],
            shipRocketUserName: [''],
            shipRocketPassword: [''],
            emailVerification: new UntypedFormControl(0),
            autoReview: [''],
            razorPayKey: [''],
            serialLine: [''],
            serialLineActive: [''],
            opwaToken: [''],
            opwaId: [''],
            opwaCountryId: [''],
            opwaUrl: [''],
            otpEnabled: [''],
            smscClientId: [''],
            smscApiKey: [''],
            smscSenderId: [''],
            otpDigit: [''],
            otpMaxDigit: [''],
            optMessageTemplate: [''],
            shippingVendor: new UntypedFormControl('Primary'),
            languageSelection: [''],
            shippingChargesApplied: [''],
            freeShippingAppliedAmount: [''],
            avaliablePincodes: [''],
            author: ['', [Validators.required]],
            description: ['', [Validators.required]],
            keywords: ['', [Validators.required]],
            smsVendor: [''],
            googleSocialLogin: [''],
            googleSocialLoginStatus: [''],
            showCartProductPage: [''],
            showCartIncremented: [1],
            showConfigurableDropdownProductPage: [1],
            showGenuineProductIcon: [1],
            showTimeIcon: [1],
            deliveryDoorStepIcon: [1],
            passwordValidationRequired: [1],
            genuineProductText: ['', []],
            deliveryDoorStepText: ['', []],
            deliveryTime: ['', []],
            passwordMinimumCharacters: [8],
            crossSellProductsText: ['Cross Sells Products', [Validators.required]],
            relatedProductsText: ['Related Products', [Validators.required]],
            recentlyViewedProductsText: ['Recently Viewed', [Validators.required]],
            upSellProductsText: ['Up Sells Products', [Validators.required]],
            enableStorePickup: [0, [Validators.required]],
            checkoutTimerEnabled: [0, [Validators.required]],
            checkoutTimerSeconds: [360, [Validators.required]],
            googleAnalyticsId: [''],
            facebookPixelId: [''],
            googleSiteVerification: [''],
            supplierLatitude: [0, [Validators.required]],
            supplierLongitude: [0, [Validators.required]],
            manualOrderTriggeredForDelivery: [0, [Validators.required]],
            orderLastDispatchedTime: [0, [Validators.required]],
            maximumDeliveryKm: [0, [Validators.required]],
            googleMapAvaliable: [0, [Validators.required]],
            googleMapApiKey: [],
            additionalDeliveryCharge: [0, [Validators.required]],
            additionalDeliveryChargeInPercent: [0, [Validators.required]],
            calculateShippingRateBasedOnVendors: [0, [Validators.required]],
            deliveryClosed: [0, [Validators.required]],
            smtpUsername: ['speedup', [Validators.required]],
            posEnabled: [0],
            posUrl: [''],
            posUsername: [''],
            posPassword: [''],
            type: [''],
            posVendor: [''],
            whatsAppVendor: [''],
            botBobaAuthToken: [''],
            botBabaId: [''],
            botEnabled: [0],
            botUrl: [''],
            removeExpiryProductFromStock: [0],
            updateStockByPurchaseOnly: [0],
            productsImageHeight: [0, [Validators.required]],
            enableGst: [1],
            enableStockInHand: [0],
            showFooterIcon: [0],
            showContactNumber: [0],
            showGstInAddress: [0],
            showGstInUser: [0],
            showContactPage: [0],
            showBlogPage: [0],
            chatVendor: [0],
            chatEnabled: [1],
            tawkToUrl: [''],
            orderTemplateId: ['Template 2'],
            invoiceTemplateId: ['Template 2'],
            partialPaymentMinimumAmount: [0],
            partialPayment: [0.0],
            editParitialAmount: [0],
            calculateParitialAmountPercent: [0],
            partialPaymentInfo: [''],
            productsImageWidth: ['250', [Validators.required]],
            productsImageType: [1],
            categoryMenuType: [1],
            whatsAppButtonEnableProduct: [1],
            productImageWidth: ['70', [Validators.required]],
            footerLayoutColour: ['#000000', [Validators.required]],
            footerLayoutFontColour: ['#FFFFFF', [Validators.required]],
            apiKey: [''],
            authDomain: [''],
            projectId: [''],
            storageBucket: [''],
            messagingSenderId: [''],
            appId: [''],
            productzoom: [''],
            productsImageWidthMob: ['150', [Validators.required]],
            productsImageHeightMob: ['200', [Validators.required]],
            vendorEnabled: [1],
            smsUrl: [''],
            smsDisabled: [''],
            orderMessageTemplate: [''],
            invoiceMessageTemplate: [''],
            shipmentMessageTemplate: [''],
            refundMessageTemplate: [''],
            smsVerification: [0],
            guestLogin: [0],
            coversionTrackingIdGa: [''],
            predefinedColor: [2],
            gmcVerificationCode: [''],
            fbVerificationCode: [''],
            productImageHeight: [''],
            producImageWidth: [''],
            productMImageWidth: [''],
            productMImageHeight: [''],
            showGstCartPage: [0],
            showExclusivePrice: [0],
            b2bPricingEnabled: [0],
            disableCoupoun: [0],
            priceSortings: [''],
            footerLayout: [1],
            productDetailPage: [1],
            themeSecondaryColor: [1],
            showBrochurePage: [0],
            gmcCredentials: [''],
            bannerHeight: ['450px'],
            bannerWidth: ['450px'],
            bannerMobHeight: ['150px'],
            bannerMobWidth: ['150px'],
            gmcConnected: [0],
            totalNumberOfPrimaryMenuDisplayed: ['2', [Validators.required]],
            useCommonReferral: ['1'],
            showAnimation: ['0'],
            showLeftMenu: [0],
            displayPincode: [0],
            hideFooterMob: [0],
            defaultFooter: [0],
            paddingGapXsLeft: [''],
            paddingGapXsRight: [''],
            paddingGapSmLeft: [''],
            paddingGapSmRight: [''],
            paddingGapMdLeft: [''],
            paddingGapMdRight: [''],
            paddingGapLgLeft: [''],
            paddingGapLgRight: [''],
            paddingGapXlLeft: [''],
            paddingGapXlRight: [''],
            defaultPaddingLeft: [''],
            defaultPaddingRight: [''],
            merchantId: [''],
            payUKey: [''],
            payUSalt: [''],
            payUUrl: [''],
            easeBuzzEnvironment: [''],
            easeBuzzAccessKey: [''],
            easeBuzzTransApiLink: [''],
            easeBuzzSalt: [''],
            categoryImgHeight: [''],
            categoryImgWidth: [''],
            cashFreeEnvironment: [''],
            cashFreeApiId: [''],
            cashFreeSecretKey: [''],
            enableEnquire: [''],
            disablePrice: [''],
            disablePriceInDetailPage: [''],
            stripeKey: [''],
            stripeCurrency: [''],
            hsnNumber: [0],
            paytmMerchantId: [''],
            paytmEnvironment: [0],
            paypalKey: [''],
            paypalEnvironment: [0],
            paypalCurrency: [''],
            displayNameFully: [0],
            logoPositionMobile: [0],
            stripeSecretCode: [],
            spinnerEnabled: [1],
            spinnerVendor: [0],
            wheeloScriptId: [''],
            displayAccountName: [0],
            orderReceivedTemplate: [''],
            outOfStockTemplate: [''],
            outOfStockTemplateNotificationForAdmin: [''],
            outOfStockNotifiedForCustomer: [''],
            outOfStockNotifiedForAdmin: [''],
            orderNotificationSmsToAdmin: [0],
            googleApi: [''],
            cancelEnabled: [0],
            ccavenueCurrency: [''],
            ccavenueLanguage: [''],
            homePageLayoutLoadedMob: [],
            homePageLayoutLoadedWeb: [],
            headerEnabled: [0],
            productNameCenter: [0],
            subscribeText: ['Subscribe Our Newsletter', [Validators.required]],
            inclTaxEnabled: [0],
            mobileHeaderColour: ['#000000'],
            mobileHeaderType: [0],
            productPriceCenter: [0],
            pushNotificationEnable: [0],
            pushNotificationOneSignalKey: [],
            pushNotificationAdminNotify: [],
            pushNotificationOneSignalAppId: [],
            pushNotificationRestKey: [],
            headerIconColour: [],
            googleMapsEnabled: [0],
            deliveryRange: [],
            codPaymentCharge: [],
            codPaymentMessage: ['Cod Charges'],
            footerLogoSrc: [''],
            outofstockEnabled: [0],
            additionalPaymentText: [''],
            headerNotificationContent: [''],
            headerLogoSrc: [''],
            mobileFontSize: [''],
            shareChat: [''],
            hompageLayoutSpace: [''],
            mobileLogoSrc: [''],
            faviconSrc: [''],
            mobileLogoEnable: [''],
            faviconEnable: [''],
            mobileHeaderHeight: [''],
            mobileHeaderLogoGap: [''],
            bannerTabletHeight: [''],
            bannerTabletWeight: [''],
            blogSize: [''],
            categoryPageProductNameMobHeight: [''],
            categoryPageProductNameHeight: [''],
            categoryPageProductNameDisplayLine: [''],
            categoryPageProductNameDisplayLineMobHeight: [''],
            websiteBackgoundColor: [''],
            referEarnEnable: [''],
            displayMrpPrice: [''],
            icarryUserName: [''],
            icarryPassword: [''],
            xpressbeesUserName: [''],
            xpressbeesPassword: [''],
            taxName: [''],
            checkoutPageType: [''],
            specialPriceChangeOnPriceDiscount: [''],
            enableDiscountOnMrpPrice: [''],
            priceDetailType: [''],
            certificateDetailType: [''],
            slotTiming: [''],
            maintainCoreSlotTiming: [''],
            slotType: [0],
            categoryImageDisplayHomepage: [0],
            categoryImageDisplayHeight: [''],
            categoryImageDisplayWidth: [''],
            footerImageEnable: [0],
            dspeedupNavigationEnable: [0],
            phonePeUrl: [''],
            phonePeMerchantId: [''],
            phonePeSaltKeys: [''],
            categoryColor: [''],
            headerBannerTextColour: [''],
            addToCartType: [0],
            addToCartSymbolType: [0],
            doctorDetailsPageText: [''],
            headerBannerCopyCoupon: [''],
            headerBannerCopyEnable: [0],
            imageResizing: [1],
            gmcBrandName: [''],
            homePageBackgroundImgSrc: [''],
            certificateBackgroundImg: [''],
            courseManagerSign: [''],
            homePageScreenSize: [''],
            homePageBackgroundEnable: [0],
            blogImageHeight: [''],
            blogImageWidth: [''],
            blogImageHeightMob: [''],
            blogImageWidthMob: [''],
            blogOverallHeight: [''],
            blogOverallHeightMob: [''],
            blogNameDisplayLine: [''],
            blogNameDisplayLineMob: [''],
            refundPolicyName: [''],
            bookingCheckoutPageName: [''],
            bookingConfirmBtnName: [''],
            certificateEnablePercentage: [''],
            certificateType: [''],
            googleMapEnable: [''],
            googleMapNavigation: [''],
            mobileLeftRightScroll: [''],
            adsHomePageImage: [''],
            adsHomePageTitle: [''],
            adsHomePageDescription: [''],
            categroySubmenuColumn: [''],
            carouselIconColor: [''],
            productLayoutType: [0],
            websiteFontFamily: [''],
            adsEnableHomePage: [0],
            adsHomePageType: [0],
            typeFormEnableHomePage: [0],
            typeFormIdHomePageTitle: [''],
            productsDisplayCount: [''],
            mobileProductsDisplayCount: [''],
            courseVedioDisplayMobileApp: [0],
            androidAppLink: [''],
            iosAppLink: [''],
            sizeChartWidth: [''],
            sizeChartEnable: [0],
            showCategoryEnable: [0],
            filterCategoryName: [''],
            footerScrollText: [''],
            footerScrollTextEnable: [0],
            footerScrollTextColor: [''],
            footerScrollTextBackgourndColor: [''],
            footerScrollCallUsNo: [''],
            headerBannerRotateEnable: [0],
            productDetailPageSubimageHeight: [''],
            cartPageType: [0],
            breadcrumbType: [0],
            indiaMartLeadEnabled: [0],
            indiaMartApiKey: [''],
            indiaMartSchedulerTimer: [''],
            orderStatusType: [0],
            enableFooterWebsite: [0],
            disableCartIconInHeader: [1],
            disablePaymentPolicy: [1],
            disableShippingPolicy: [1],
            disableRefundPolicy: [1],
            disableVisaCard: [1],
            disableLoginHeader: [0],
            disableWishlistHeader: [0],
            disableCartInDetailPage: [0],
            enablePolicyInMob: [0],
            disableYourOrders: [0],
            disableSearchInHeader: [0],
            enableCustomOption: [0],
            customOptionFooter: [''],
            customOptionNavigationLink: [''],
            facebookAccessToken: [''],
            facebookGraphUrl: [''],
            twitterLoginStatus: [0],
            enableBreadcrumbPages: [0],
            enableBreadcrumbGeneral: [0],
            enablePickDate: [],
            pickDateText: [],
            enableMessageDetailPage: [''],
            messageText: [''],
            popupForm: [''],
            popupText: [''],
            disableMyAppointment: [''],
            decimalDigit: [''],
            enableReferalCustomerDiscount: [''],
            otpText: [''],
            otpShowType: [''],
            referralLoginTitle: [''],
            referralPopupForm: [''],
            referralType: [''],
            marginTopEnableWithBreadCrump: [''],
            startOptMessage: [''],
            endOptMessage: [''],
            enableOptMessage: [''],
            hideSellerAddress: [''],
            technicianAssignType: [''],
            layoutDisplayTypeInDetailpage: [''],
            enablePartner: [''],
            categoryMenuMobileType: [''],
            enableVoiceReaderInDetailPage: [''],
            enableWhatsappChat: [''],
            showSecondaryStatusOrders: [''],
            statusChangeMessageTemplate: [''],
            productImageZoom: [''],
            storeDescription: [''],
            bannerHeightInCategoryPage: [''],
            bannerMobileHeightInCategoryPage: [''],
            pancardNo: [''],
            noPaddingFooter: [''],
            footerBrandImg: [''],
            passwordMinimumCharactersMobileApp: [''],
            footerBackgroundImg: [''],
            secondaryLogo: [''],
            secondaryBackground: [''],
            voiceMenuType: [1],
            categoryMenuDisplayType: [1],
            headerBannerBackgroundColors: [''],
            coursePopupTitle: [''],
            coursePopupDescriptionContent: [''],
            playstoreAppVersion: [''],
            playstoreAppVersionLink: [''],
            listingId: [''],
            displayDeliveryIcon: [''],
            deliveryIconImage: [''],
            appUpdate: [0],
            popUpHeight: [''],
            popUpWidth: [''],
            deliveryIconNavigationLink: [''],
            redirectToLoginPage: [''],
            courseHistorySeconds: [''],
            enableFooterWhatsapp: [''],
            enableMylearning: [''],
            categoryFontSize: [''],
            showDeliveryPeopleAssignType: [''],
            deliveryTipAmount: [''],
            enableDeliveryTip: [''],
            deliveryInformationText: [''],
            enableDeliveryInformation: [''],
            sheetId: [''],
            sheetCredentials: [''],
            facebookConnected: [''],
            customButtonInCategroyPage: [''],
            categoryPageImageLayout: [''],
            disableSortParam: [''],
            enableDownloadPdf: [''],
            disablePriceFilter: [''],
            messageRequired: [''],
            messageEdit: [''],
            websiteLogoSize: [''],
            timeOut: [''],
            maxAttempt: [''],
            defaultId: [''],
            printTimeInOrder: [''],
            deliverySlotEnable: [''],
            orderDirectInvoiceEnable: [''],
            warehouseBasedAllocation: [''],
            deliverySlotTiming: [''],
            adminBreadcrumbType: [''],
            deliverySlotPeriod: [''],
            noStopOtp: [0],
            commissionType: [1],
            autoEnableCommision: [0],
            deliveryDefaultStatus: [],
            logoWaterMark: [''],
            supplierRegistrationType: [''],
            supplierRegistrationPages: [''],
            leftMenuHideInMobile: [''],
            ipGeoLocation: [''],
            defaultDoctorAccessSet: [''],
            orderType: [''],
            menuIconColor: [''],
            menuTextColor: [''],
            layoutMainType: [''],
            gridType: [1],
            blogLeftGap: [''],
            blogRightGap: [''],
            blogLeftGapMob: [''],
            blogRightGapMob: [''],
            blogType: [''],
            courseDetailPageType: [''],
            clarityId: [''],
            clarityEnabled: [0],
            browserGraphImage: [''],
            shippingAmountName: ['Shipping Amount'],
            filterType: [0],
            robotsText: [''],
            uploadSiteMap: [''],
            schemaMarkup: [''],
            popupFormSubmittedType: [1],
            menuType: [1],
            adminLayout: ['compact'],
            blogPageType: [0],
            linkedinConversationId: [''],
            sendReminderGoldCustomer: [0],
            pushNotificationUrl: [''],
            pushNotificationServiceAccount: [''],
            phonePeClientId: [''],
            orderInvoiceSentWhatsapp: [''],
            dashboardeditbutton: [''],
            phonePeClientVersion: [''],
            phonePeClientSecret: [''],
            phonePeTokenUrl: [''],
            defaultProductSet: [''],
            pincodeBasedPrice: [''],
            orderSuccessNavigated: [''],
            dashboardGap: [''],
            dashboardGapMobile: [''],
            orderUrl: [''],
            invoiceNoType: [0],
            cartPageLayout: [''],
            accountInformationType: [0],
            expressDeliveryCharge: [''],
            loginType: [0],
            reOrder: [0],
            productMobileGap: [''],
            productWebGap: [''],
            tabDisplayCount: ['3'],
            searchDisplayCountWeb: ['4'],
            searchDisplayCountMobile: ['2'],
            searchDisplayCountTab: ['3'],
            tabWebGap: [''],
            disableFilter: [0],
            shippingRateType: [''],
            orderAdminPage: [1],
            adminHeader: [1],
            orderWhatsAppMessageTemplate: [''],
            invoiceWhatsAppMessageTemplate: [''],
            shipmentWhatsAppMessageTemplate: [''],
            refundWhatsAppMessageTemplate: [''],
            orderWhatsAppMessageTemplateId: [''],
            invoiceWhatsAppMessageTemplateId: [''],
            shipmentWhatsAppMessageTemplateId: [''],
            refundWhatsAppMessageTemplateId: [''],
            skuAutoGenerate: [0],
            shipwayToken: [],
            defaultSupplierAccessSet: [''],
            vendorPaymentLink: [''],
            deleteUserOption: [1],
            cuisines: [],
            razorPaySecret: [''],
            chromeExtensionId: [],
            returnRequestDay: [''],
            encryptedText: [''],
            enableExchange: [''],
            enableDemoVideoLinks: [0],
        },
        );

        this.path1 = this.serverPath2 + this.firstFormGroup.value.headerLogoSrc;

        this.path = this.serverPath1 + this.firstFormGroup.value.footerLogoSrc;

        this.path2 = this.serverPath3 + this.firstFormGroup.value.mobileLogoSrc;

        this.path3 = this.serverPath4 + this.firstFormGroup.value.faviconSrc;

        this.path5 = this.serverPath6 + this.firstFormGroup.value.adsHomePageImage;

        this.path6 = this.serverPath7 + this.firstFormGroup.value.footerBrandImg;
    }

    booleanFieldNumber: any = [
        { "value": 1, "viewValue": "Yes" },
        { "value": 0, "viewValue": "No" },
    ]


    enableFooterWhatsapp: any = [
        { "value": 1, "viewValue": "Call Us" },
        { "value": 2, "viewValue": "Whatsapp Us" },
        { "value": 0, "viewValue": "Display Both" },
    ]

    otpShowType: any = [
        { "value": "1", "viewValue": "Display Start And End Opt" },
        { "value": "0", "viewValue": "Start Opt" },
    ]

    referralType: any = [
        { "value": 0, "viewValue": "Type 1" },
        { "value": 1, "viewValue": "Type 2" },
    ]

    disableCartIconInHeader: any = [
        { "value": 0, "viewValue": "Yes" },
        { "value": 1, "viewValue": "No" },
    ]

    disableCartIconInHeader1: any = [
        { "value": 1, "viewValue": "Yes" },
        { "value": 0, "viewValue": "No" },
    ]

    enableFooterWebsite: any = [
        { "value": 0, "viewValue": "Yes" },
        { "value": 1, "viewValue": "No" },
    ]

    booleanTips: any = [
        { "value": 1, "viewValue": "Yes" },
        { "value": 0, "viewValue": "No" },
    ]
    booleannoStopOtp: any = [
        { "value": 1, "viewValue": "Yes" },
        { "value": 0, "viewValue": "No" },
    ]

    appUpdate: any = [
        { "value": 0, "viewValue": "Yes" },
        { "value": 1, "viewValue": "No" },
    ]

    Redirect: any = [
        { "value": 0, "viewValue": "Home" },
        { "value": 1, "viewValue": "Login" },
    ]

    showDeliveryPeopleAssignType: any = [
        { "value": 0, "viewValue": "Primary" },
        { "value": 1, "viewValue": "Secondary" },
    ]

    disableSortParam: any = [
        { "value": 0, "viewValue": "Yes" },
        { "value": 1, "viewValue": "No" },
    ]

    leftMenuHideInMobile: any = [
        { "value": 1, "viewValue": "Yes" },
        { "value": 0, "viewValue": "No" },
    ]


    booleanFieldNumber1: any = [
        { "value": 1, "viewValue": "Type-1" },
        { "value": 0, "viewValue": "Type-2" },
    ]

    adsHomePageType: any = [
        { "value": 1, "viewValue": "Type-1" },
        { "value": 0, "viewValue": "Type-2" },
        { "value": 2, "viewValue": "Type-3" },
        { "value": 3, "viewValue": "Type-4" },
    ]

    mobileHeaderType: any = [
        { "value": 1, "viewValue": "Type-1" },
        { "value": 0, "viewValue": "Type-2" },
        { "value": 2, "viewValue": "Type-3" },
        { "value": 3, "viewValue": "Type-4" },
        { "value": 4, "viewValue": "Type-5" },
        { "value": 5, "viewValue": "Type-6" },
        { "value": 6, "viewValue": "Type-7" },
        { "value": 7, "viewValue": "Type-8" },
        { "value": 8, "viewValue": "Type-9" },

    ]

    showAnimation: any = [
        { "value": 1, "viewValue": "Type-1" },
        { "value": 0, "viewValue": "Type-2" },
        { "value": 2, "viewValue": "Type-3" },
    ]

    booleanField: any = [
        { "value": "1", "viewValue": "Yes" },
        { "value": "0", "viewValue": "No" },
    ]

    position: any = [
        { "value": "0", "viewValue": "Start" },
        { "value": "1", "viewValue": "Center" },
    ]

    environment: any = [
        { "value": "prod", "viewValue": "Prod" },
        { "value": "test", "viewValue": "Test" },
    ]

    predefinedColor: any = [
        // { "value": 1, "viewValue": "Predefined" },
        { "value": 2, "viewValue": "Others" },
        { "value": 3, "viewValue": "Custom" },
    ]

    useCommonReferral: any = [
        { "value": 1, "viewValue": "Default" },
        { "value": 2, "viewValue": "Others" },
    ]




    imageHeight: any = [
        { "value": "Small", "viewValue": 200 },
        { "value": "Medium", "viewValue": 280 },
        { "value": "Large", "viewValue": 335 },
        { "value": "Custom", "viewValue": 200 },
    ]

    imageHeightNew: any = [
        { "value": "Small", "viewValue": 200, "final": 1 },
        { "value": "Medium", "viewValue": 280, "final": 2 },
        { "value": "Large", "viewValue": 335, "final": 3 },
        { "value": "Custom", "viewValue": 200, "final": 4 },
    ]



    numbers: any = [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18
    ]


    decimalDigit: any = [
        { "value": 0, "viewValue": "Disable" },
        { "value": 1, "viewValue": "1" },
        { "value": 2, "viewValue": "2" },
        { "value": 3, "viewValue": "3" },
        { "value": 4, "viewValue": "4" },
    ]


    voiceMenuType: any = [
        { "value": 1, "viewValue": "1" },
        { "value": 2, "viewValue": "2" },
        { "value": 3, "viewValue": "3" },
    ]

    blogPageType: any = [
        { "value": 0, "viewValue": "Type 1" },
        { "value": 1, "viewValue": "Type 2" },
    ]

    categoryMenuDisplayType: any = [
        { "value": 1, "viewValue": "Upper Case" },
        { "value": 2, "viewValue": "Lower Case" },
        { "value": 3, "viewValue": "Title Case" },
        { "value": 4, "viewValue": "Default" },
    ]


    shippingVendor = [
        { "viewValue": "Primary", "value": "primary" },
        { "viewValue": "Ship Rocket", "value": "shipRocket" },
        { "viewValue": "Aromex", "value": "aromex" },
        { "viewValue": "Own Delivery", "value": "delivery" },
        // { "viewValue": "CustomMap", "value": "customMap" },
    ]

    adminmenutype: any = [
        { "viewValue": "Centered", "value": "centered" },
        { "viewValue": "Enterprise", "value": "enterprise" },
        { "viewValue": "Material", "value": "material" },
        { "viewValue": "Modern", "value": "modern" },
        { "viewValue": "Basic", "value": "basic" },
        { "viewValue": "Classic", "value": "classic" },
        { "viewValue": "Classy", "value": "classy" },
        { "viewValue": "Compact", "value": "compact" },
        { "viewValue": "Dense", "value": "dense" },
        { "viewValue": "Furturistic", "value": "futuristic" },
        { "viewValue": "Thin", "value": "thin" },
    ]

    display: any = false;
    userNameCopied = false;
    passwordCopied = false;
    accountCopied = false;
    baseUrlCopied = false;
    showCopiedFeedback(type: string) {
        this[`${type}Copied`] = true;
        setTimeout(() => {
            this[`${type}Copied`] = false;
        }, 2000);
    }

    plan: any;

    baseUrl: any;

    accountPlan: any;

    planList: any[] = [
        { value: 1, viewValue: 'Ecommerc-Pro' },
        { value: 2, viewValue: 'Ecommerce-Basic' },
        { value: 3, viewValue: 'Ecommerce-Lite' },
        { value: 4, viewValue: 'Ecommerce-Free' },
        { value: 5, viewValue: 'Partner' },
        { value: 6, viewValue: 'Unlimited' },
        { value: 7, viewValue: 'HRM' },
        { value: 8, viewValue: 'Erp' },
        { value: 10, viewValue: 'Erp & Crm' },
        { value: 12, viewValue: 'Starter' },
        { value: 13, viewValue: 'Professional' },
        { value: 15, viewValue: 'Unlimited Max' },
        { value: 16, viewValue: 'Whatsapp' },
        { value: 17, viewValue: 'Ecommerce' },
        { value: 18, viewValue: 'Enterprise' },
        { value: 19, viewValue: 'CRM-Pos-Whatsapp' },
        { value: 20, viewValue: 'VendorUsers' },
        { value: 21, viewValue: 'Crm Advance' },
        { value: 22, viewValue: 'Sequence' },
        { value: 23, viewValue: 'Callyzer' },
        { value: 24, viewValue: 'Free Plan' },
    ];

    get planName(): string {
        const found = this.planList.find(p => p.value === +this.accountPlan);
        return found ? found.viewValue : this.accountPlan || 'N/A';
    }

    ngOnInit() {

        this.plan = localStorage.getItem('plan');

        this.accountPlan = localStorage.getItem('accountPlan');

        this.whatsappCreated = localStorage.getItem('whatsappCreated');

        this.baseUrl = localStorage.getItem('baseUrl');

        this.formSubmitted = localStorage.getItem("formSubmitted");

        const encryptedSigninDetails = localStorage.getItem('signinDetails');

        if (encryptedSigninDetails) {
            const decrypted = this.ecryptService.decryptionAES(encryptedSigninDetails);
            const signinDetails = JSON.parse(decrypted);
            this.userName = signinDetails.userName;
            console.log("signinDetails", signinDetails);

        }


        let value1 = localStorage.getItem(Constant.USER_DETAILS);

        if (value1 != undefined) {

            let object = this.encryptedService.decryptionAES(value1);

            if (object != undefined) {

                this.userList = JSON.parse(object);

                this.display = true;

                localStorage.removeItem(Constant.USER_DETAILS);

            }
        }


        this.firstFormGroup?.controls?.AdminMenuType?.valueChanges.subscribe(value => {
            if (value) {
                localStorage.setItem('adminmenutype', value);
            }
        });
        this.imageSrc = this.serverPath + 'logo.webp';
        this.path3 = this.serverPath4 + 'fav.png';

        this.generalForm();
        this.getCurrencyList();
        this.currencyYFilter();
        this.getAllCurrency();
        this.getAccessList();
        this.AccessYFilter();
        this.getAllAccessSet();

        this.getdynamicForm();

        this.getCountryList();
        this.getConfigData();
        this.countrYFilter();
        this.getAllCountry();
        this.mobileQuery.matches ? this.closeDrawer() : this.openDrawer();
        this._mobileQueryListener = () => {
            this.mobileQuery.matches ? this.closeDrawer() : this.openDrawer();
            this.cd.detectChanges();
        };
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd),
            filter(() => this.mobileQuery.matches),
            untilDestroyed(this)
        ).subscribe(() => this.closeDrawer());
        this.menu = 0;
        this.text = "Save";

    }


    ngAfterViewInit() {

        this.plan = localStorage.getItem('plan');

        this.baseUrl = localStorage.getItem('baseUrl');

    }

    logo() {
        this.logoVisible = false;
    }

    logoBg() {
        this.logoBGVisible = false
    }

    logoBigs() {
        console.log('hello');

        this.bigLogoVisible = false
    }

    secondaryLogo() {
        console.log('hello');

        this.secondaryLogoVisible = false
    }

    secondaryBackgroundLogo() {
        console.log('hello');

        this.secondaryBackgroundVisible = false
    }




    favIconVisible: any = true;

    robottextVisible: any = true;

    siteMapVisible: any = true;

    favIcon() {


        this.favIconVisible = false
    }

    robortText() {

        this.robottextVisible = false
    }


    siteMap() {

        this.siteMapVisible = false
    }


    getResult(event, i) {


        if (i == 1) {
            this.logoVisible = true;
        } else if (i == 2) {
            this.logoBGVisible = true;
        } else if (i == 4) {
            this.favIconVisible = true;

        } else if (i == 5) {
            this.firstFormGroup.controls.secondaryLogo.setValue('secondaryLogo.webp');
            this.secondaryLogoVisible = true;
        } else if (i == 6) {
            this.secondaryBackgroundVisible = true;
        } else if (i == 7) {
            this.robottextVisible = true;
        }
        else if (i == 8) {
            this.siteMapVisible = true;
        }

        else {
            this.bigLogoVisible = true
        }


        this.snackBar.open("Image Uploaded Successfully..", '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
    }

    cancelUpload(i) {
        if (i == 1) {
            this.logoVisible = true;
        } else if (i == 2) {
            this.logoBGVisible = true;
        } else if (i == 4) {
            this.favIconVisible = true;
        } else if (i == 5) {
            this.secondaryLogoVisible = true;
        } else if (i == 6) {
            this.secondaryBackgroundVisible = true;
        } else if (i == 7) {
            this.robottextVisible = true;
        } else if (i == 8) {
            this.siteMapVisible = true;
        }
        else {
            this.bigLogoVisible = true
        }
    }


    drawerChange(drawerOpen: boolean) {
        this.screenSizeService.drawerOpen.next(drawerOpen);
    }

    openDrawer() {
        this.screenSizeService.drawerOpen.next(true);
        this.cd.markForCheck();
    }

    closeDrawer() {
        this.screenSizeService.drawerOpen.next(false);
        this.cd.markForCheck();
    }

    scrollToBottom() {
        this.scrollbar.scrollbarRef.getScrollElement().scrollTo({
            behavior: 'smooth',
            top: 0
        });
    }


    menuLink(i) {
        this.menu = i;
        this.scrollToBottom()
        if (this.mobileQuery.matches) {
            this.screenSizeService.drawerOpen.next(false);
        }
    }


    back() {
        this.location.back();
    }

    links: any = [
        { value: '0', viewValue: 'General' },
        { value: '1', viewValue: 'Design' },
        { value: '2', viewValue: 'Store' },
        { value: '3', viewValue: 'Payment-Gateway' },
        { value: '4', viewValue: 'Courier' },
        { value: '5', viewValue: 'SMS' },
        { value: '6', viewValue: 'Shipping Configuration' },
        { value: '7', viewValue: 'SEO' },
        { value: '8', viewValue: 'Social-Login' },
        { value: '9', viewValue: 'Analytics' },
        { value: '10', viewValue: 'Pos' },
        { value: '11', viewValue: 'Whats-App-bot' },
        { value: '12', viewValue: 'Chat-bot' },
        { value: '13', viewValue: 'Mail' },
        { value: '14', viewValue: 'Payment Configuration' },
        { value: '15', viewValue: 'Product Configuration' },
        { value: '16', viewValue: 'Google Map' },
        { value: '17', viewValue: 'Push Notification' },
        { value: '18', viewValue: 'Booking' },
        { value: '19', viewValue: 'Course' },

    ]


    getConfigData(): void {

        this.configService.getConfigDataNew().subscribe(
            (response: any) => {

                try {

                    let config = response;

                    if (response.encryptedText != null) {
                        const decrypted = this.ecryptService.decryptionAES(response.encryptedText);
                        config = JSON.parse(decrypted);
                    }

                    this.editConfig(config);
                } catch (e) {
                    console.error('Config decrypt/parse failed', e);
                }
            },
            (err) => {
                console.error('getConfigDataNew API failed', err);
            }
        );
    }



    editConfig(config: any) {

        const selectedType = config.filterType;
        if (selectedType !== null && selectedType !== undefined) {
            this.onFilterChange(selectedType);
        } else {
            this.onFilterChange(0);
        }

        this.highlighted = config.color !== null ? config.color : 'red';

        this.selectLayout = this[config.layout];


        if (config.predefinedColor == 2) {

            let colour = config.color.replace(/[0-9]/g, '')

            this.firstIndex = this.configurationDropDownList.findIndex(x => x['key'] == colour);
            if (this.firstIndex == -1) {
                this.firstIndex = 0;
            }
            this.secondIndex = this.configurationDropDownList[this.firstIndex]
                .recursuive.findIndex(x => x['key'] == config.color);

            if (this.secondIndex == -1) {
                this.secondIndex = 0;
            }
            this.colourCode = this.configurationDropDownList[this.firstIndex]
                .recursuive[this.secondIndex].colorCode
            this.firstDropDownValue.patchValue(this.configurationDropDownList[this.firstIndex].key)
            this.secondDropDownValue.patchValue(this.configurationDropDownList[this.firstIndex]
                .recursuive[this.secondIndex].key);

        }

        this.firstFormGroup = this.formBuilder.group({
            configId: config.configId,
            siteName: (config.siteName && config.siteName.length > 0) ? config.siteName : config.storeName,
            storeName: config.storeName,
            unsecureBaseUrl: config.unsecureBaseUrl,
            baseUrl: config.baseUrl,
            currencyBase: config.currencyBase,
            defaultTitle: config.defaultTitle,
            logoSrc: config.logoSrc,
            logoWithoutBackgroundSrc: config.logoWithoutBackgroundSrc,
            name: config.name,
            email: config.email,
            salesName: config.salesName,
            supportName: config.supportName,
            supportEmail: config.supportEmail,
            smtpHost: config.smtpHost,
            smtpPassword: config.smtpPassword,
            storePhoneNumber: config.storePhoneNumber,
            storeHoursOfOperation: config.storeHoursOfOperation,
            country: config.country,
            regionState: config.regionState,
            zipPostCode: config.zipPostCode,
            city: config.city,
            streetAddress: config.streetAddress,
            streetAddressLine2: config.streetAddressLine2,
            vatNumber: config.vatNumber,
            ssl: config.ssl,
            disableEmailCommunication: config.disableEmailCommunication,
            smtpPort: config.smtpPort,
            layout: config.layout,
            color: config.color,
            ccAvenueAccessCode: config.ccAvenueAccessCode,
            ccAvenueEncKey: config.ccAvenueEncKey,
            ccAvenueMerchantId: config.ccAvenueMerchantId,
            ccAvenueUrl: config.ccAvenueUrl,
            aromexUserName: config.aromexUserName,
            aromexPassword: config.aromexPassword,
            aromexVersion: config.aromexVersion,
            aromexAccountNumber: config.aromexAccountNumber,
            aromexAccountPin: config.aromexAccountPin,
            aromexAccountEntity: config.aromexAccountEntity,
            aromexAccountCountryCode: config.aromexAccountCountryCode,
            aromexSource: config.aromexSource,
            orderPrefix: config.orderPrefix,
            AdminMenuType: config.AdminMenuType,
            customButtonInCategroyPageNavigation: config.customButtonInCategroyPageNavigation,
            leftMenuColor: config.leftMenuColor,
            leftMenuHoverColor: config.leftMenuHoverColor,
            headerBgColor: config.headerBgColor,
            leftMenuBgColor: config.leftMenuBgColor,
            mainfontcolor: config.mainfontcolor,
            mainBgColor: config.mainBgColor,
            shipRocketUserName: config.shipRocketUserName,
            shipRocketPassword: config.shipRocketPassword,
            emailVerification: config.emailVerification,
            autoReview: config.autoReview,
            razorPayKey: config.razorPayKey,
            serialLine: config.serialLine,
            serialLineActive: config.serialLineActive,
            opwaToken: config.opwaToken,
            opwaId: config.opwaId,
            opwaCountryId: config.opwaCountryId,
            opwaUrl: config.opwaUrl,
            otpEnabled: config.otpEnabled,
            smscClientId: config.smscClientId,
            smscApiKey: config.smscApiKey,
            smscSenderId: config.smscSenderId,
            otpDigit: config.otpDigit,
            otpMaxDigit: config.otpMaxDigit,
            optMessageTemplate: config.optMessageTemplate,
            shippingVendor: config.shippingVendor,
            languageSelection: config.languageSelection,
            shippingChargesApplied: config.shippingChargesApplied,
            freeShippingAppliedAmount: config.freeShippingAppliedAmount,
            avaliablePincodes: config.avaliablePincodes,
            author: config.author,
            description: config.description,
            keywords: config.keywords,
            smsVendor: config.smsVendor,
            googleSocialLogin: config.googleSocialLogin,
            googleSocialLoginStatus: config.googleSocialLoginStatus,
            showCartProductPage: config.showCartProductPage,
            showCartIncremented: config.showCartIncremented,
            showGenuineProductIcon: config.showGenuineProductIcon,
            showTimeIcon: config.showTimeIcon,
            deliveryDoorStepIcon: config.deliveryDoorStepIcon,
            passwordValidationRequired: config.passwordValidationRequired,

            genuineProductText: config.genuineProductText,
            deliveryDoorStepText: config.deliveryDoorStepText,
            deliveryTime: config.deliveryTime,
            passwordMinimumCharacters: config.passwordMinimumCharacters,
            crossSellProductsText: config.crossSellProductsText,
            relatedProductsText: config.relatedProductsText,
            recentlyViewedProductsText: config.recentlyViewedProductsText,
            upSellProductsText: config.upSellProductsText,
            showConfigurableDropdownProductPage: config.showConfigurableDropdownProductPage,
            enableStorePickup: config.enableStorePickup,
            checkoutTimerEnabled: config.checkoutTimerEnabled,
            checkoutTimerSeconds: config.checkoutTimerSeconds,
            googleAnalyticsId: config.googleAnalyticsId,
            facebookPixelId: config.facebookPixelId,
            googleSiteVerification: config.googleSiteVerification,
            supplierLatitude: config.supplierLatitude,
            supplierLongitude: config.supplierLongitude,
            manualOrderTriggeredForDelivery: config.manualOrderTriggeredForDelivery,
            orderLastDispatchedTime: config.orderLastDispatchedTime,
            maximumDeliveryKm: config.maximumDeliveryKm,
            googleMapAvaliable: config.googleMapAvaliable,
            googleMapApiKey: config.googleMapApiKey,
            additionalDeliveryCharge: config.additionalDeliveryCharge,
            additionalDeliveryChargeInPercent: config.additionalDeliveryChargeInPercent,
            calculateShippingRateBasedOnVendors: config.calculateShippingRateBasedOnVendors,
            deliveryClosed: config.deliveryClosed,
            smtpUsername: config.smtpUsername,
            posEnabled: config.posEnabled,
            posUrl: config.posUrl,
            posUsername: config.posUsername,
            posPassword: config.posPassword,
            type: config.type,
            posVendor: config.posVendor,
            whatsAppVendor: config.whatsAppVendor,
            botBobaAuthToken: config.botBobaAuthToken,
            botBabaId: config.botBabaId,
            botEnabled: config.botEnabled,
            botUrl: config.botUrl,
            removeExpiryProductFromStock: config.removeExpiryProductFromStock,
            updateStockByPurchaseOnly: config.updateStockByPurchaseOnly,
            productsImageHeight: config.productsImageHeight,
            enableGst: config.enableGst,
            enableStockInHand: config.enableStockInHand,
            showFooterIcon: config.showFooterIcon,
            showContactNumber: config.showContactNumber,
            showGstInAddress: config.showGstInAddress,
            showGstInUser: config.showGstInUser,
            showContactPage: config.showContactPage,
            showBlogPage: config.showBlogPage,
            chatVendor: config.chatVendor,
            chatEnabled: config.chatEnabled,
            tawkToUrl: config.tawkToUrl,
            invoiceTemplateId: config.invoiceTemplateId,
            orderTemplateId: config.orderTemplateId,
            partialPayment: config.partialPayment,
            partialPaymentMinimumAmount: config.partialPaymentMinimumAmount,
            editParitialAmount: config.editParitialAmount,
            calculateParitialAmountPercent: config.calculateParitialAmountPercent,
            partialPaymentInfo: config.partialPaymentInfo,
            productsImageWidth: config.productsImageWidth,
            productsImageType: config.productsImageType,
            categoryMenuType: config.categoryMenuType,
            whatsAppButtonEnableProduct: config.whatsAppButtonEnableProduct,
            productImageWidth: config.productImageWidth,
            productzoom: config.productzoom,
            footerLayoutColour: config.footerLayoutColour,
            footerLayoutFontColour: config.footerLayoutFontColour,
            apiKey: config.apiKey,
            authDomain: config.authDomain,
            projectId: config.projectId,
            storageBucket: config.storageBucket,
            messagingSenderId: config.messagingSenderId,
            appId: config.appId,
            productsImageWidthMob: config.productsImageWidthMob,
            productsImageHeightMob: config.productsImageHeightMob,
            vendorEnabled: config.vendorEnabled,
            smsUrl: config.smsUrl,
            smsDisabled: config.smsDisabled,
            orderMessageTemplate: config.orderMessageTemplate,
            invoiceMessageTemplate: config.invoiceMessageTemplate,
            shipmentMessageTemplate: config.shipmentMessageTemplate,
            refundMessageTemplate: config.refundMessageTemplate,
            smsVerification: config.smsVerification,
            guestLogin: config.guestLogin,
            coversionTrackingIdGa: config.coversionTrackingIdGa,
            predefinedColor: config.predefinedColor,
            gmcVerificationCode: config.gmcVerificationCode,
            fbVerificationCode: config.fbVerificationCode,
            productImageHeight: config.productImageHeight,
            producImageWidth: config.producImageWidth,
            productMImageWidth: config.productMImageWidth,
            productMImageHeight: config.productMImageHeight,
            showGstCartPage: config.showGstCartPage,
            showExclusivePrice: config.showExclusivePrice,
            b2bPricingEnabled: config.b2bPricingEnabled,
            disableCoupoun: config.disableCoupoun,
            priceSortings: config.priceSortings != null ? config.priceSortings : 'price,DESC',
            footerLayout: config.footerLayout == undefined ? 1 : config.footerLayout,
            productDetailPage: config.productDetailPage,
            themeSecondaryColor: config.themeSecondaryColor,
            showBrochurePage: config.showBrochurePage,
            gmcCredentials: config.gmcCredentials,
            bannerWidth: config.bannerWidth,
            bannerHeight: config.bannerHeight,
            bannerMobWidth: config.bannerMobWidth,
            bannerMobHeight: config.bannerMobHeight,
            gmcConnected: config.gmcConnected,
            useCommonReferral: config.useCommonReferral,
            totalNumberOfPrimaryMenuDisplayed: config.totalNumberOfPrimaryMenuDisplayed,
            displayPincode: config.displayPincode,
            showLeftMenu: config.showLeftMenu,
            showAnimation: config.showAnimation,
            hideFooterMob: config.hideFooterMob,
            defaultFooter: config.defaultFooter,
            paddingGapXsLeft: config.paddingGapXsLeft,
            paddingGapXsRight: config.paddingGapXsRight,
            paddingGapSmLeft: config.paddingGapSmLeft,
            paddingGapSmRight: config.paddingGapSmRight,
            paddingGapMdLeft: config.paddingGapMdLeft,
            paddingGapMdRight: config.paddingGapMdRight,
            paddingGapLgLeft: config.paddingGapLgLeft,
            paddingGapLgRight: config.paddingGapLgRight,
            paddingGapXlLeft: config.paddingGapXlLeft,
            paddingGapXlRight: config.paddingGapXlRight,
            defaultPaddingRight: config.defaultPaddingRight,
            defaultPaddingLeft: config.defaultPaddingLeft,
            merchantId: config.merchantId,
            payUKey: config.payUKey,
            payUSalt: config.payUSalt,
            payUUrl: config.payUUrl,
            easeBuzzEnvironment: config.easeBuzzEnvironment,
            easeBuzzAccessKey: config.easeBuzzAccessKey,
            easeBuzzTransApiLink: config.easeBuzzTransApiLink,
            easeBuzzSalt: config.easeBuzzSalt,
            categoryImgHeight: config.categoryImgHeight,
            categoryImgWidth: config.categoryImgWidth,
            cashFreeEnvironment: config.cashFreeEnvironment,
            cashFreeApiId: config.cashFreeApiId,
            cashFreeSecretKey: config.cashFreeSecretKey,
            enableEnquire: config.enableEnquire,
            disablePrice: config.disablePrice,
            disablePriceInDetailPage: config.disablePriceInDetailPage,
            stripeKey: config.stripeKey,
            stripeCurrency: config.stripeCurrency,
            hsnNumber: config.hsnNumber,
            paytmMerchantId: config.paytmMerchantId,
            paytmEnvironment: config.paytmEnvironment,
            paypalCurrency: config.paypalCurrency,
            paypalKey: config.paypalKey,
            paypalEnvironment: config.paypalEnvironment,
            displayNameFully: config.displayNameFully,
            logoPositionMobile: config.logoPositionMobile,
            stripeSecretCode: config.stripeSecretCode,
            wheeloScriptId: config.wheeloScriptId,
            spinnerVendor: config.spinnerVendor,
            spinnerEnabled: config.spinnerEnabled,
            displayAccountName: config.displayAccountName,
            orderReceivedTemplate: config.orderReceivedTemplate,
            outOfStockTemplate: config.outOfStockTemplate,
            outOfStockTemplateNotificationForAdmin: config.outOfStockTemplateNotificationForAdmin,
            outOfStockNotifiedForCustomer: config.outOfStockNotifiedForCustomer,
            outOfStockNotifiedForAdmin: config.outOfStockNotifiedForAdmin,
            orderNotificationSmsToAdmin: config.orderNotificationSmsToAdmin,
            googleApi: config.googleApi,
            cancelEnabled: config.cancelEnabled,
            ccavenueCurrency: config.ccavenueCurrency,
            ccavenueLanguage: config.ccavenueLanguage,
            homePageLayoutLoadedWeb: config.homePageLayoutLoadedWeb,
            homePageLayoutLoadedMob: config.homePageLayoutLoadedMob,
            headerEnabled: config.headerEnabled,
            productNameCenter: config.productNameCenter,
            subscribeText: config.subscribeText,
            inclTaxEnabled: config.inclTaxEnabled,
            mobileHeaderColour: config.mobileHeaderColour,
            mobileHeaderType: config.mobileHeaderType,
            productPriceCenter: config.productPriceCenter,
            pushNotificationEnable: config.pushNotificationEnable,
            pushNotificationOneSignalKey: config.pushNotificationOneSignalKey,
            pushNotificationAdminNotify: config.pushNotificationAdminNotify,
            pushNotificationOneSignalAppId: config.pushNotificationOneSignalAppId,
            pushNotificationRestKey: config.pushNotificationRestKey,
            headerIconColour: config.headerIconColour,
            googleMapsEnabled: config.googleMapsEnabled,
            deliveryRange: config.deliveryRange,
            codPaymentCharge: config.codPaymentCharge,
            codPaymentMessage: config.codPaymentMessage,
            footerLogoSrc: config.footerLogoSrc,
            outofstockEnabled: config.outofstockEnabled,
            additionalPaymentText: config.additionalPaymentText,
            headerNotificationContent: config.headerNotificationContent,
            headerLogoSrc: config.headerLogoSrc,
            mobileFontSize: config.mobileFontSize,
            shareChat: config.shareChat,
            hompageLayoutSpace: config.hompageLayoutSpace,
            mobileLogoSrc: config.mobileLogoSrc,
            faviconSrc: config.faviconSrc,
            mobileLogoEnable: config.mobileLogoEnable,
            faviconEnable: config.faviconEnable,
            mobileHeaderHeight: config.mobileHeaderHeight,
            mobileHeaderLogoGap: config.mobileHeaderLogoGap,
            bannerTabletHeight: config.bannerTabletHeight,
            bannerTabletWeight: config.bannerTabletWeight,
            blogSize: config.blogSize,
            categoryPageProductNameHeight: config.categoryPageProductNameHeight,
            categoryPageProductNameMobHeight: config.categoryPageProductNameMobHeight,
            categoryPageProductNameDisplayLine: config.categoryPageProductNameDisplayLine,
            categoryPageProductNameDisplayLineMobHeight: config.categoryPageProductNameDisplayLineMobHeight,
            websiteBackgoundColor: config.websiteBackgoundColor,
            referEarnEnable: config.referEarnEnable,
            displayMrpPrice: config.displayMrpPrice,
            icarryUserName: config.icarryUserName,
            icarryPassword: config.icarryPassword,
            xpressbeesUserName: config.xpressbeesUserName,
            xpressbeesPassword: config.xpressbeesPassword,
            taxName: config.taxName,
            checkoutPageType: config.checkoutPageType,
            specialPriceChangeOnPriceDiscount: config.specialPriceChangeOnPriceDiscount,
            enableDiscountOnMrpPrice: config.enableDiscountOnMrpPrice,
            priceDetailType: config.priceDetailType,
            certificateDetailType: config.certificateDetailType,
            slotTiming: config.slotTiming,
            maintainCoreSlotTiming: config.maintainCoreSlotTiming,
            slotType: config.slotType,
            categoryImageDisplayHomepage: config.categoryImageDisplayHomepage,
            categoryImageDisplayHeight: config.categoryImageDisplayHeight,
            categoryImageDisplayWidth: config.categoryImageDisplayWidth,
            footerImageEnable: config.footerImageEnable,
            dspeedupNavigationEnable: config.dspeedupNavigationEnable,
            phonePeUrl: config.phonePeUrl,
            phonePeMerchantId: config.phonePeMerchantId,
            phonePeSaltKeys: config.phonePeSaltKeys,
            categoryColor: config.categoryColor,
            headerBannerTextColour: config.headerBannerTextColour,
            addToCartType: config.addToCartType,
            addToCartSymbolType: config.addToCartSymbolType,
            doctorDetailsPageText: config.doctorDetailsPageText,
            headerBannerCopyEnable: config.headerBannerCopyEnable,
            headerBannerCopyCoupon: config.headerBannerCopyCoupon,
            imageResizing: config.imageResizing,
            gmcBrandName: config.gmcBrandName,
            homePageScreenSize: config.homePageScreenSize,
            homePageBackgroundImgSrc: config.homePageBackgroundImgSrc,
            certificateBackgroundImg: config.certificateBackgroundImg,
            courseManagerSign: config.courseManagerSign,
            homePageBackgroundEnable: config.homePageBackgroundEnable,
            blogImageHeight: config.blogImageHeight,
            blogImageWidth: config.blogImageWidth,
            blogImageHeightMob: config.blogImageHeightMob,
            blogImageWidthMob: config.blogImageWidthMob,
            blogOverallHeight: config.blogOverallHeight,
            blogOverallHeightMob: config.blogOverallHeightMob,
            blogNameDisplayLine: config.blogNameDisplayLine,
            blogNameDisplayLineMob: config.blogNameDisplayLineMob,
            refundPolicyName: config.refundPolicyName,
            bookingCheckoutPageName: config.bookingCheckoutPageName,
            bookingConfirmBtnName: config.bookingConfirmBtnName,
            certificateEnablePercentage: config.certificateEnablePercentage,
            certificateType: config.certificateType,
            googleMapNavigation: config.googleMapNavigation,
            googleMapEnable: config.googleMapEnable,
            mobileLeftRightScroll: config.mobileLeftRightScroll,
            adsHomePageImage: config.adsHomePageImage,
            adsHomePageTitle: config.adsHomePageTitle,
            adsHomePageDescription: config.adsHomePageDescription,
            categroySubmenuColumn: config.categroySubmenuColumn,
            carouselIconColor: config.carouselIconColor,
            productLayoutType: config.productLayoutType,
            websiteFontFamily: config.websiteFontFamily,
            adsEnableHomePage: config.adsEnableHomePage,
            adsHomePageType: config.adsHomePageType,
            typeFormEnableHomePage: config.typeFormEnableHomePage,
            typeFormIdHomePageTitle: config.typeFormIdHomePageTitle,
            productsDisplayCount: config.productsDisplayCount,
            mobileProductsDisplayCount: config.mobileProductsDisplayCount,
            courseVedioDisplayMobileApp: config.courseVedioDisplayMobileApp,
            androidAppLink: config.androidAppLink,
            iosAppLink: config.iosAppLink,
            sizeChartWidth: config.sizeChartWidth,
            sizeChartEnable: config.sizeChartEnable,
            showCategoryEnable: config.showCategoryEnable,
            filterCategoryName: config.filterCategoryName,
            footerScrollText: config.footerScrollText,
            footerScrollTextEnable: config.footerScrollTextEnable,
            footerScrollTextColor: config.footerScrollTextColor,
            footerScrollTextBackgourndColor: config.footerScrollTextBackgourndColor,
            footerScrollCallUsNo: config.footerScrollCallUsNo,
            headerBannerRotateEnable: config.headerBannerRotateEnable,
            productDetailPageSubimageHeight: config.productDetailPageSubimageHeight,
            cartPageType: config.cartPageType,
            breadcrumbType: config.breadcrumbType,
            indiaMartLeadEnabled: config.indiaMartLeadEnabled,
            indiaMartApiKey: config.indiaMartApiKey,
            indiaMartSchedulerTimer: config.indiaMartSchedulerTimer,
            orderStatusType: config.orderStatusType,
            enableFooterWebsite: config.enableFooterWebsite,
            disableCartIconInHeader: config.disableCartIconInHeader,
            disablePaymentPolicy: config.disablePaymentPolicy,
            disableShippingPolicy: config.disableShippingPolicy,
            disableRefundPolicy: config.disableRefundPolicy,
            disableVisaCard: config.disableVisaCard,
            disableLoginHeader: config.disableLoginHeader,
            disableWishlistHeader: config.disableWishlistHeader,
            disableCartInDetailPage: config.disableCartInDetailPage,
            enablePolicyInMob: config.enablePolicyInMob,
            disableYourOrders: config.disableYourOrders,
            disableSearchInHeader: config.disableSearchInHeader,
            enableCustomOption: config.enableCustomOption,
            customOptionFooter: config.customOptionFooter,
            customOptionNavigationLink: config.customOptionNavigationLink,
            facebookAccessToken: config.facebookAccessToken,
            facebookGraphUrl: config.facebookGraphUrl,
            twitterLoginStatus: config.twitterLoginStatus,
            enableBreadcrumbPages: config.enableBreadcrumbPages,
            enableBreadcrumbGeneral: config.enableBreadcrumbGeneral,
            enablePickDate: config.enablePickDate,
            pickDateText: config.pickDateText,
            enableMessageDetailPage: config.enableMessageDetailPage,
            messageText: config.messageText,
            popupForm: config.popupForm,
            popupText: config.popupText,
            disableMyAppointment: config.disableMyAppointment,
            decimalDigit: config.decimalDigit,
            enableReferalCustomerDiscount: config.enableReferalCustomerDiscount,
            otpText: config.otpText,
            otpShowType: config.otpShowType,
            referralLoginTitle: config.referralLoginTitle,
            referralPopupForm: config.referralPopupForm,
            referralType: config.referralType,
            marginTopEnableWithBreadCrump: config.marginTopEnableWithBreadCrump,
            startOptMessage: config.startOptMessage,
            endOptMessage: config.endOptMessage,
            enableOptMessage: config.enableOptMessage,
            hideSellerAddress: config.hideSellerAddress,
            technicianAssignType: config.technicianAssignType,
            layoutDisplayTypeInDetailpage: config.layoutDisplayTypeInDetailpage,
            enablePartner: config.enablePartner,
            categoryMenuMobileType: config.categoryMenuMobileType,
            enableVoiceReaderInDetailPage: config.enableVoiceReaderInDetailPage,
            enableWhatsappChat: config.enableWhatsappChat,
            showSecondaryStatusOrders: config.showSecondaryStatusOrders,
            statusChangeMessageTemplate: config.statusChangeMessageTemplate,
            productImageZoom: config.productImageZoom,
            storeDescription: config.storeDescription,
            bannerHeightInCategoryPage: config.bannerHeightInCategoryPage,
            bannerMobileHeightInCategoryPage: config.bannerMobileHeightInCategoryPage,
            pancardNo: config.pancardNo,
            noPaddingFooter: config.noPaddingFooter,
            footerBrandImg: config.footerBrandImg,
            passwordMinimumCharactersMobileApp: config.passwordMinimumCharactersMobileApp,
            footerBackgroundImg: config.footerBackgroundImg,
            secondaryLogo: config.secondaryLogo,
            secondaryBackground: config.secondaryBackground,
            voiceMenuType: config.voiceMenuType,
            categoryMenuDisplayType: config.categoryMenuDisplayType,
            headerBannerBackgroundColors: config.headerBannerBackgroundColors,
            playstoreAppVersion: config.playstoreAppVersion,
            playstoreAppVersionLink: config.playstoreAppVersionLink,
            coursePopupTitle: config.coursePopupTitle,
            coursePopupDescriptionContent: config.coursePopupDescriptionContent,
            listingId: config.listingId,
            displayDeliveryIcon: config.displayDeliveryIcon,
            deliveryIconImage: config.deliveryIconImage,
            appUpdate: config.appUpdate == null ? 0 : config.appUpdate,
            popUpHeight: config.popUpHeight,
            popUpWidth: config.popUpWidth,
            deliveryIconNavigationLink: config.deliveryIconNavigationLink,
            redirectToLoginPage: config.redirectToLoginPage,
            courseHistorySeconds: config.courseHistorySeconds,
            enableFooterWhatsapp: config.enableFooterWhatsapp,
            enableMylearning: config.enableMylearning,
            categoryFontSize: config.categoryFontSize,
            showDeliveryPeopleAssignType: config.showDeliveryPeopleAssignType,
            deliveryTipAmount: config.deliveryTipAmount,
            enableDeliveryTip: config.enableDeliveryTip,
            enableDeliveryInformation: config.enableDeliveryInformation,
            deliveryInformationText: config.deliveryInformationText,
            sheetId: config.sheetId,
            sheetCredentials: config.sheetCredentials,
            facebookConnected: config.facebookConnected,
            customButtonInCategroyPage: config.customButtonInCategroyPage,
            categoryPageImageLayout: config.categoryPageImageLayout,
            disableSortParam: config.disableSortParam,
            enableDownloadPdf: config.enableDownloadPdf,
            disablePriceFilter: config.disablePriceFilter,
            messageRequired: config.messageRequired,
            messageEdit: config.messageEdit,
            websiteLogoSize: config.websiteLogoSize,
            timeOut: config.timeOut,
            maxAttempt: config.maxAttempt,
            defaultId: config.defaultId,
            printTimeInOrder: config.printTimeInOrder,
            deliverySlotEnable: config.deliverySlotEnable,
            orderDirectInvoiceEnable: config.orderDirectInvoiceEnable,
            warehouseBasedAllocation: config.warehouseBasedAllocation,
            deliverySlotTiming: config.deliverySlotTiming,
            adminBreadcrumbType: config.adminBreadcrumbType,
            deliverySlotPeriod: config.deliverySlotPeriod,
            noStopOtp: config.noStopOtp,
            commissionType: config.commissionType,
            autoEnableCommision: config.autoEnableCommision,
            deliveryDefaultStatus: config.deliveryDefaultStatus,
            logoWaterMark: config.logoWaterMark,
            supplierRegistrationType: config.supplierRegistrationType,
            supplierRegistrationPages: config.supplierRegistrationPages,
            leftMenuHideInMobile: config.leftMenuHideInMobile,
            ipGeoLocation: config.ipGeoLocation,
            defaultDoctorAccessSet: config.defaultDoctorAccessSet,
            orderType: config.orderType,
            menuIconColor: config.menuIconColor,
            menuTextColor: config.menuTextColor,
            layoutMainType: config.layoutMainType,
            gridType: config.gridType,
            blogLeftGap: config.blogLeftGap,
            blogRightGap: config.blogRightGap,
            blogLeftGapMob: config.blogLeftGapMob,
            blogRightGapMob: config.blogRightGapMob,
            blogType: config.blogType,
            courseDetailPageType: config.courseDetailPageType,
            clarityId: config.clarityId,
            clarityEnabled: config.clarityEnabled,
            browserGraphImage: config.browserGraphImage,
            shippingAmountName: config.shippingAmountName,
            filterType: config.filterType,
            robotsText: config.robotsText,
            uploadSiteMap: config.uploadSiteMap,
            schemaMarkup: config.schemaMarkup,
            popupFormSubmittedType: config.popupFormSubmittedType,
            menuType: config.menuType,
            adminLayout: config.adminLayout,
            blogPageType: config.blogPageType,
            linkedinConversationId: config.linkedinConversationId,
            sendReminderGoldCustomer: config.sendReminderGoldCustomer,
            pushNotificationUrl: config.pushNotificationUrl,
            pushNotificationServiceAccount: config.pushNotificationServiceAccount,
            phonePeClientId: config.phonePeClientId,
            orderInvoiceSentWhatsapp: config.orderInvoiceSentWhatsapp,
            dashboardeditbutton: config.dashboardeditbutton,
            phonePeClientVersion: config.phonePeClientVersion,
            phonePeClientSecret: config.phonePeClientSecret,
            phonePeTokenUrl: config.phonePeTokenUrl,
            pincodeBasedPrice: config.pincodeBasedPrice,
            orderSuccessNavigated: config.orderSuccessNavigated,
            dashboardGap: config.dashboardGap || 20,
            dashboardGapMobile: config.dashboardGapMobile || 10,
            orderUrl: config.orderUrl,
            defaultProductSet: parseInt(config.defaultProductSet),
            productNewType: config.productNewType,
            invoiceNoType: config.invoiceNoType,
            cartPageLayout: config.cartPageLayout,
            accountInformationType: config.accountInformationType,
            expressDeliveryCharge: config.expressDeliveryCharge,
            loginType: config.loginType,
            reOrder: config.reOrder,
            productMobileGap: config.productMobileGap,
            productWebGap: config.productWebGap,
            tabDisplayCount: config.tabDisplayCount,
            searchDisplayCountWeb: config.searchDisplayCountWeb,
            searchDisplayCountMobile: config.searchDisplayCountMobile,
            searchDisplayCountTab: config.searchDisplayCountTab,
            tabWebGap: config.tabWebGap,
            disableFilter: config.disableFilter,
            shippingRateType: config.shippingRateType,
            orderAdminPage: config.orderAdminPage,
            adminHeader: config.adminHeader == null ? 1 : config.adminHeader,
            orderWhatsAppMessageTemplate: config.orderWhatsAppMessageTemplate,
            invoiceWhatsAppMessageTemplate: config.invoiceWhatsAppMessageTemplate,
            shipmentWhatsAppMessageTemplate: config.shipmentWhatsAppMessageTemplate,
            refundWhatsAppMessageTemplate: config.refundWhatsAppMessageTemplate,
            orderWhatsAppMessageTemplateId: config.orderWhatsAppMessageTemplateId,
            invoiceWhatsAppMessageTemplateId: config.invoiceWhatsAppMessageTemplateId,
            shipmentWhatsAppMessageTemplateId: config.shipmentWhatsAppMessageTemplateId,
            refundWhatsAppMessageTemplateId: config.refundWhatsAppMessageTemplateId,
            skuAutoGenerate: config.skuAutoGenerate,
            shipwayToken: config.shipwayToken,
            defaultSupplierAccessSet: config.defaultSupplierAccessSet,
            vendorPaymentLink: config.vendorPaymentLink,
            deleteUserOption: config.deleteUserOption,
            razorPaySecret: config.razorPaySecret,
            chromeExtensionId: config.chromeExtensionId,
            returnRequestDay: config.returnRequestDay,
            encryptedText: config.encryptedText,
            enableExchange: config.enableExchange,
            enableDemoVideoLinks: config.enableDemoVideoLinks
        });
        this.path = this.serverPath1 + config.footerLogoSrc

        this.path1 = this.serverPath2 + config.headerLogoSrc

        this.path2 = this.serverPath3 + config.mobileLogoSrc

        this.path3 = this.serverPath4 + config.faviconSrc

        this.path4 = this.serverPath5 + config.homePageBackgroundImgSrc

        this.path5 = this.serverPath6 + config.adsHomePageImage

        this.path6 = this.serverPath7 + config.footerBrandImg

        this.path7 = this.serverPath8 + config.footerBackgroundImg

        this.path8 = this.serverPath9 + config.certificateBackgroundImg

        this.path9 = this.serverPath10 + config.courseManagerSign

        this.path10 = this.serverPath11 + config.deliveryIconImage

        this.path11 = this.serverPath12 + config.categoryPageImageLayout

        this.path12 = this.serverPath13 + config.logoWaterMark

        this.path13 = this.serverPath14 + config.browserGraphImage

        if (config.footerLogoSrc != null) {
            if (config.footerLogoSrc.length > 0) {
                this.imageDelete = true;
            }
        }

        if (config.headerLogoSrc != null) {
            if (config.headerLogoSrc.length > 0) {
                this.imageDelete1 = true;
            }
        }
        if (config.mobileLogoSrc != null) {
            if (config.mobileLogoSrc.length > 0) {
                this.imageDelete2 = true;
            } else {
                this.imageVisible2 = true;
            }
        }

        if (config.faviconSrc != null) {
            if (config.faviconSrc.length > 0) {
                this.imageDelete3 = true;
            }
        }

        if (config.homePageBackgroundImgSrc != null) {
            if (config.homePageBackgroundImgSrc.length > 0) {
                this.imageDelete4 = true;
            }
        }

        if (config.adsHomePageImage != null) {
            if (config.adsHomePageImage.length > 0) {
                this.imageDelete5 = true;
            }
        }

        if (config.footerBrandImg != null) {
            if (config.footerBrandImg.length > 0) {
                this.imageDelete6 = true;
            }
        }

        if (config.footerBackgroundImg != null) {
            if (config.footerBackgroundImg.length > 0) {
                this.imageDelete7 = true;
            }
        }

        if (config.certificateBackgroundImg != null) {
            if (config.certificateBackgroundImg.length > 0) {
                this.imageDelete8 = true;
            }
        }

        if (config.courseManagerSign != null) {
            if (config.courseManagerSign.length > 0) {
                this.imageDelete9 = true;
            }
        }

        if (config.categoryPageImageLayout != null) {
            if (config.categoryPageImageLayout.length > 0) {
                this.imageDelete10 = true;
            }
        }

        if (config.logoWaterMark != null) {
            if (config.logoWaterMark.length > 0) {
                this.imageDelete12 = true;
            }
        }

        if (config.browserGraphImage != null) {
            if (config.browserGraphImage.length > 0) {
                this.imageDelete13 = true;
            }
        }

        //    this.showDeliveryPeopleAssignType = config['showDeliveryPeopleAssignType'];

        this.getAllDeliveryPeopleList();
    }

    saveConfig() {
        if (this.firstFormGroup.valid) {
            const shouldOpenWhatsappAfterSave = localStorage.getItem("userCreated") === "1";

            if (this.firstFormGroup.value.predefinedColor == 2) {
                this.firstFormGroup.value.color = this.secondDropDownValue.value;
            }

            this.configService.saveConfigMain(this.firstFormGroup.value).subscribe(
                (response) => {
                    if (response['status_code'] == Constant.RESPONSE_SUCCESS) {

                        this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });

                        this.text = "Processing";

                        if (this.plan == 6) {
                            localStorage.setItem("userCreated", "2");
                        } else {
                            localStorage.removeItem("userCreated");
                        }

                        localStorage.setItem("formSubmitted", "0");


                        const encryptedConfig = this.ecryptService.encryptionAES(JSON.stringify(response['data']));
                        localStorage.setItem('configSettingsData', encryptedConfig);

                        let data = response['data']
                        if (data['mainBgColor'] != undefined) {
                            let mainBg = data['mainBgColor'];
                            document.documentElement.style.setProperty('--mainbackground-color', mainBg);
                        }

                        if (data['filterType'] != undefined) {
                            let filterType = data['filterType'];
                            localStorage.setItem('filterType', filterType);
                        }
                        if (data['gridType'] != undefined) {
                            let gridType = data['gridType'];
                            localStorage.setItem('gridType', gridType);
                        }
                        if (data['dashboardGap'] != undefined) {
                            let dashboardGap = data['dashboardGap'];
                            localStorage.setItem('dashboardGap', dashboardGap);
                        }
                        if (data['dashboardGapMobile'] != undefined) {
                            let dashboardGapMobile = data['dashboardGapMobile'];
                            localStorage.setItem('dashboardGapMobile', dashboardGapMobile);
                        }

                        if (data['storeName'] != undefined) {
                            let storeName = data['storeName'];
                            localStorage.setItem('storeName', storeName);
                        }

                        if (data['adminLayout'] != undefined) {
                            let adminLayout = data['adminLayout'];
                            localStorage.setItem('adminLayout', adminLayout);
                        }

                        if (data['leftMenuColor'] != undefined) {
                            let leftMenuColor = data['leftMenuColor'];
                            document.documentElement.style.setProperty('--leftprimary-color', leftMenuColor);
                        }
                        if (data['leftMenuHoverColor'] != undefined) {
                            let leftMenuHoverColor = data['leftMenuHoverColor'];
                            document.documentElement.style.setProperty('--leftmenuhover-color', leftMenuHoverColor);
                        }
                        if (data['leftMenuBgColor'] != undefined) {
                            let leftMenuBgColor = data['leftMenuBgColor'];
                            document.documentElement.style.setProperty('--leftbackground-color', leftMenuBgColor);
                        }
                        if (data['mainfontcolor'] != undefined) {
                            let mainBackgroundColor = data['mainfontcolor'];
                            document.documentElement.style.setProperty('--backgroundmain-color', mainBackgroundColor);
                        }

                        this.router.navigate(['/dashboard']);

                        if (shouldOpenWhatsappAfterSave && (this.formSubmitted == "0" || this.formSubmitted == null || this.formSubmitted == undefined || this.formSubmitted == "")) {

                            this.getAccountData();
                        } else {
                            this.dialogRef.close();
                        }

                    } else {
                        this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
                    }


                },
                (err) => { }
            );
        } else {
            this.firstFormGroup.markAllAsTouched();
        }
    }

    accountList: any;

    getAccountData() {
        this.accountService.getAllAccountsBYtenant().subscribe(
            data => {


                this.accountList = data;

                if (this.accountList.length > 0) {

                    const account = this.accountList[0];

                    const today = new Date().toISOString().split('T')[0];

                    const createdDate = new Date(account.createdDate).toISOString().split('T')[0];

                    if (createdDate === today) {
                        this.enableTour();
                    } else {
                        this.dialogRef.close();
                    }


                    this._changeDetectorRef.detectChanges();

                } else {
                    this.dialogRef.close();

                }

            }




        )
    }

      enableTour() {
    this.tourService.startTour();
  }

    whatsappDialogPopup(account: any) {
        const dialogConfig: any = {
            disableClose: true,
            data: {
                plan: this.plan,
                account: account
            }
        };

        if (window.innerWidth > 768) {
            dialogConfig.width = '790px';
        }
        else {
            dialogConfig.minWidth = '100vw';
            dialogConfig.height = '100vh';
        }

        this.dialogRef.close();

        setTimeout(() => {
            let dialogRef = this.dialog.open(WhatappIntegrationPopupComponent, dialogConfig);

            dialogRef.disableClose = true;
            dialogRef.afterClosed().subscribe(result => {
                if (result && result['event'] == 'add') {

                }
            });
        });

    }


    // design layout

    layout: any = [
        { "id": 1, "layout": "one" },
        { "id": 2, "layout": "two" },
        { "id": 3, "layout": "three" },
        { "id": 4, "layout": "four" },
        { "id": 5, "layout": "five" },
        { "id": 6, "layout": "six" },
        { "id": 7, "layout": "seven" },
        { "id": 8, "layout": "eight" },
        { "id": 9, "layout": "nine" },
        { "id": 10, "layout": "ten" },
        { "id": 11, "layout": "eleven" },
        { "id": 12, "layout": "twelve" },
        { "id": 13, "layout": "thirteen" },
        { "id": 14, "layout": "fourteen" },
        { "id": 15, "layout": "fifteen" },
        { "id": 16, "layout": "sixteen" },
        { "id": 17, "layout": "seventeen" },
        { "id": 18, "layout": "eighteen" },
        { "id": 19, "layout": "nineteen" },
        { "id": 20, "layout": "twenty" },
        { "id": 21, "layout": "twentyOne" },
        { "id": 22, "layout": "twentytwo" },
        { "id": 23, "layout": "twentythree" },
        { "id": 24, "layout": "twentyfour" },
        { "id": 25, "layout": "twentyfive" },
        { "id": 26, "layout": "twentysix" },
        { "id": 27, "layout": "twentyseven" },
        { "id": 28, "layout": "twentyeight" },
        { "id": 29, "layout": "twentynine" },
        { "id": 30, "layout": "thirty" },
        { "id": 31, "layout": "thirtyone" },
        { "id": 32, "layout": "thirtytwo" },
        { "id": 33, "layout": "thirtythree" },
        { "id": 34, "layout": "thirtyfour" },
        { "id": 35, "layout": "thirtyfive" },
        { "id": 36, "layout": "thirtysix" },
        { "id": 37, "layout": "thirtyseven" },
        { "id": 38, "layout": "thirtyeight" },
        { "id": 39, "layout": "thirtynine" },
        { "id": 40, "layout": "fourty" },
        { "id": 41, "layout": "fourtyone" },
        { "id": 42, "layout": "fourtytwo" },
        { "id": 43, "layout": "fourtythree" },
        { "id": 44, "layout": "fourtyfour" },
        { "id": 45, "layout": "fourtyfive" },
        { "id": 46, "layout": "fourtysix" },
    ]

    orderTemplate: any = [
        { "id": 'orderInvoice', "layout": "Template 1" },
        { "id": 'rajshriInvoice', "layout": "Template 2" },
        { "id": 'newTaxInvoice', "layout": "Template 3" },
        { "id": 'newTaxInvoice2', "layout": "Template 4" },
        { "id": 'orderInvoiceNew', "layout": "Template 5" },
        { "id": 'orderInvoiceNew1', "layout": "Template 6" },
        { "id": 'orderInvoiceNew2', "layout": "Template 7" },
        { "id": 'orderInvoiceNew8', "layout": "Template 8" },
        { "id": 'orderInvoiceNew9', "layout": "Template 9" },
        { "id": 'jolzsmartInvoice', "layout": "Template 10" },
    ]



    one: any = [
        { "layout": "1", "value": "assets/images/layout/layout-one-indigo.png", "name": "Indigo" },
        { "layout": "1", "value": "assets/images/layout/layout-one-green.png", "name": "Green" },
        { "layout": "1", "value": "assets/images/layout/layout-one-blue.png", "name": "Blue" },
        { "layout": "1", "value": "assets/images/layout/layout-one-teal.png", "name": "Teal" },
        { "layout": "1", "value": "assets/images/layout/layout-one-pink.png", "name": "Pink" },
        { "layout": "1", "value": "assets/images/layout/layout-three-red.png", "name": "Red" },
        { "layout": "1", "value": "assets/images/layout/layout-one-purple.png", "name": "Purple" },
        { "layout": "1", "value": "assets/images/layout/layout-one-yellow.png", "name": "Yellow" },
    ]

    two: any = [
        { "layout": "2", "value": "assets/images/layout/layout-two-indigo.png", "name": "Indigo" },
        { "layout": "2", "value": "assets/images/layout/layout-two-green.png", "name": "Green" },
        { "layout": "2", "value": "assets/images/layout/layout-two-blue.png", "name": "Blue" },
        { "layout": "2", "value": "assets/images/layout/layout-two-teal.png", "name": "Teal" },
        { "layout": "2", "value": "assets/images/layout/layout-two-pink.png", "name": "Pink" },
        { "layout": "2", "value": "assets/images/layout/layout-two-red.png", "name": "Red" },
        { "layout": "2", "value": "assets/images/layout/layout-two-purple.png", "name": "Purple" },
        { "layout": "2", "value": "assets/images/layout/layout-two-yellow.png", "name": "Yellow" },
    ]


    three: any = [
        { "layout": "3", "value": "assets/images/layout/layout-three-indigo.png", "name": "Indigo" },
        { "layout": "3", "value": "assets/images/layout/layout-three-green.png", "name": "Green" },
        { "layout": "3", "value": "assets/images/layout/layout-three-blue.png", "name": "Blue" },
        { "layout": "3", "value": "assets/images/layout/layout-three-teal.png", "name": "Teal" },
        { "layout": "3", "value": "assets/images/layout/layout-three-pink.png", "name": "Pink" },
        { "layout": "3", "value": "assets/images/layout/layout-one-red.png", "name": "Red" },
        { "layout": "3", "value": "assets/images/layout/layout-three-purple.png", "name": "Purple" },
        { "layout": "3", "value": "assets/images/layout/layout-three-yellow.png", "name": "Yellow" },
    ]

    four: any = [
        { "layout": "3", "value": "assets/images/layout/layout-four-indigo.png", "name": "Indigo" },
        { "layout": "3", "value": "assets/images/layout/layout-four-green.png", "name": "Green" },
        { "layout": "3", "value": "assets/images/layout/layout-four-blue.png", "name": "Blue" },
        { "layout": "3", "value": "assets/images/layout/layout-four-teal.png", "name": "Teal" },
        { "layout": "3", "value": "assets/images/layout/layout-four-pink.png", "name": "Pink" },
        { "layout": "3", "value": "assets/images/layout/layout-four-red.png", "name": "Red" },
        { "layout": "3", "value": "assets/images/layout/layout-four-purple.png", "name": "Purple" },
        { "layout": "3", "value": "assets/images/layout/layout-four-yellow.png", "name": "Yellow" },
    ]


    seven: any = [
        { "layout": "1", "value": "assets/images/layout/layout-one-indigo.png", "name": "Indigo" },
        { "layout": "1", "value": "assets/images/layout/layout-one-green.png", "name": "Green" },
        { "layout": "1", "value": "assets/images/layout/layout-one-blue.png", "name": "Blue" },
        { "layout": "1", "value": "assets/images/layout/layout-one-teal.png", "name": "Teal" },
        { "layout": "1", "value": "assets/images/layout/layout-one-pink.png", "name": "Pink" },
        { "layout": "1", "value": "assets/images/layout/layout-three-red.png", "name": "Red" },
        { "layout": "1", "value": "assets/images/layout/layout-one-purple.png", "name": "Purple" },
        { "layout": "1", "value": "assets/images/layout/layout-one-yellow.png", "name": "Yellow" },
    ]

    six: any = [
        { "layout": "2", "value": "assets/images/layout/layout-two-indigo.png", "name": "Indigo" },
        { "layout": "2", "value": "assets/images/layout/layout-two-green.png", "name": "Green" },
        { "layout": "2", "value": "assets/images/layout/layout-two-blue.png", "name": "Blue" },
        { "layout": "2", "value": "assets/images/layout/layout-two-teal.png", "name": "Teal" },
        { "layout": "2", "value": "assets/images/layout/layout-two-pink.png", "name": "Pink" },
        { "layout": "2", "value": "assets/images/layout/layout-two-red.png", "name": "Red" },
        { "layout": "2", "value": "assets/images/layout/layout-two-purple.png", "name": "Purple" },
        { "layout": "2", "value": "assets/images/layout/layout-two-yellow.png", "name": "Yellow" },
    ]


    eight: any = [
        { "layout": "3", "value": "assets/images/layout/layout-three-indigo.png", "name": "Indigo" },
        { "layout": "3", "value": "assets/images/layout/layout-three-green.png", "name": "Green" },
        { "layout": "3", "value": "assets/images/layout/layout-three-blue.png", "name": "Blue" },
        { "layout": "3", "value": "assets/images/layout/layout-three-teal.png", "name": "Teal" },
        { "layout": "3", "value": "assets/images/layout/layout-three-pink.png", "name": "Pink" },
        { "layout": "3", "value": "assets/images/layout/layout-one-red.png", "name": "Red" },
        { "layout": "3", "value": "assets/images/layout/layout-three-purple.png", "name": "Purple" },
        { "layout": "3", "value": "assets/images/layout/layout-three-yellow.png", "name": "Yellow" },
    ]

    nine: any = [
        { "layout": "3", "value": "assets/images/layout/layout-four-indigo.png", "name": "Indigo" },
        { "layout": "3", "value": "assets/images/layout/layout-four-green.png", "name": "Green" },
        { "layout": "3", "value": "assets/images/layout/layout-four-blue.png", "name": "Blue" },
        { "layout": "3", "value": "assets/images/layout/layout-four-teal.png", "name": "Teal" },
        { "layout": "3", "value": "assets/images/layout/layout-four-pink.png", "name": "Pink" },
        { "layout": "3", "value": "assets/images/layout/layout-four-red.png", "name": "Red" },
        { "layout": "3", "value": "assets/images/layout/layout-four-purple.png", "name": "Purple" },
        { "layout": "3", "value": "assets/images/layout/layout-four-yellow.png", "name": "Yellow" },
    ]




    onChange(newValue) {

        this.selectLayoutValue = newValue;
        this.selectLayout = this[newValue];
    }


    // store info
    getCountryList() {
        this.commonService.getCountryList().subscribe(
            data => {
                this.allCountryList = data;
                this.countryTypeList = data;
                this.filteredcountryTypeList = this.countryTypeList;

            }
        )
    }



    setCountryId(event) {
        let index = this.allCountryList.findIndex(x => x.countryName == event.value)
        this.firstFormGroup.value.country = this.allCountryList[index].countryName;

    }

    filterCountry(value: any): string[] {
        var filterValue: any;
        if (value != '' && typeof value == 'string') {
            filterValue = value.toLowerCase();
        } else if (typeof value == "object") {
            if (value['countryId'] != undefined) {
                filterValue = value['countryName'];
                this.firstFormGroup.patchValue({ country: value['countryName'] });
                filterValue = filterValue.toLowerCase();
            }
        } else {
            filterValue = "";
        }
        return this.countryTypeList.filter(option => option.country.toLowerCase().includes(filterValue));
    }
    private _filter(value: any): string[] {
        const filterValue = value.toLowerCase();
        return this.options.filter(option => option.toLowerCase().includes(filterValue));
    }

    getAllCountry() {
        this.filteredcountryTypeList = this.countryTypeList;
    }

    countrYFilter() {
        this.countryFilterControl.valueChanges
            .pipe(takeUntil(this._onDestroy))
            .subscribe(() => {
                this.countryFilter();
            });
    }

    protected countryFilter() {
        if (!this.countryTypeList) {
            return;
        }
        // get the search keyword
        let search = this.countryFilterControl.value;
        if (!search) {
            this.filteredcountryTypeList = this.countryTypeList.slice();
            return;
        } else {
            search = search.toLowerCase();
        }
        // filter the banks
        this.filteredcountryTypeList = this.countryTypeList.filter(country => country['countryName'].toLowerCase().indexOf(search) > -1)
    }


    changeTheme(i) {
        this.highlighted = i;
        this.firstFormGroup.value.color = i;
        this.firstFormGroup.patchValue(this.firstFormGroup.value)
    }


    emailVarify: any = [
        { id: 0, status: "NO" },
        { id: 1, status: "YES" }

    ]

    blogType: any = [
        { id: 0, status: "Type 1" },
        { id: 1, status: "Type 2" }
    ]

    Count: any = [
        { id: "1", status: "One" },
        { id: "2", status: "Two" },
        { id: "3", status: "Three" },
        { id: "4", status: "Four" },
        { id: "5", status: "Five" },


    ]

    Count1: any = [
        { id: "1", status: "One" },
        { id: "2", status: "Two" },
        // { id: "3", status: "Three" },
        // { id: "4", status: "Four" },
        // { id: "5", status: "Five" },


    ]


    popupFormSubmittedType: any = [
        { "value": 1, "viewValue": "Form Submission" },
        { "value": 0, "viewValue": "Vendor Submission" },
        // { "value":  2, "viewValue": "Calculation Submission" },
        // { "value":  3, "viewValue": "Register" },
        { "value": 4, "viewValue": "Form Submission New" },
    ]


    smsVendor: any = [
        { id: "1", status: "SMSC" },
        { id: "2", status: "FAST-SMS" },
        { id: "3", status: "SMSL" },
        { id: "4", status: "SMS-ALERT" },
        { id: "5", status: "PING-SMS" }

    ]

    showExclusivePrice = [
        { "viewValue": "Yes", "value": 1 },
        { "viewValue": "No", "value": 0 }
    ]


    vendor: any = [
        // { id: 0, status: "Default" },
        { id: 0, status: "BotBaba" }

    ]


    websiteChat: any = [
        // { id: 0, status: "Default" },
        { id: 1, status: "tawk.to" }

    ]

    websiteDiscount: any = [
        { id: 1, status: "wheelofpopups.com" }
    ]

    _keyPress(event: any) {
        const pattern = /[0-9]/;
        let inputChar = String.fromCharCode(event.charCode);
        if (!pattern.test(inputChar)) {
            event.preventDefault();
        }
    }


    ///currency code

    //country
    currencyList: any;
    currencyTypeList: any = [];
    filteredcurrencyTypeList: any = [];
    currencyControl: UntypedFormControl = new UntypedFormControl();
    currencyFilterControl: UntypedFormControl = new UntypedFormControl();




    getCurrencyList() {

        this.currencyList = this.currencycode;
        this.currencyTypeList = this.currencyList;
        this.filteredcurrencyTypeList = this.currencyTypeList;

    }

    getAllCurrency() {
        this.filteredcurrencyTypeList = this.currencyTypeList;
    }

    currencyYFilter() {
        this.currencyFilterControl.valueChanges
            .pipe(takeUntil(this._onDestroy1))
            .subscribe(() => {
                this.currencyFilter();
            });
    }

    protected currencyFilter() {
        if (!this.currencyTypeList) {
            return;
        }
        // get the search keyword
        let search = this.currencyFilterControl.value;
        if (!search) {
            this.filteredcurrencyTypeList = this.currencyTypeList.slice();
            return;
        } else {
            search = search.toLowerCase();
        }
        // filter the banks

        this.filteredcurrencyTypeList = this.currencyTypeList.filter(currency => currency['displayname'].toLowerCase().indexOf(search) > -1)
    }


    /// end of country 

    @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        this.openDrawer()
    }

    change(i) {

        console.log(i);

        let value = i;

        if (value == 1) {

            this.setValue(200, 165);
        } else if (value == 2) {

            this.setValue(280, 165);
        } else if (value == 3) {

            this.setValue(335, 165);
        } else {
            this.setValue(200, 165);
        }


    }

    setValue(i, j) {
        this.firstFormGroup.value.productsImageHeight = i;
        this.firstFormGroup.value.productsImageWidth = j;
        this.firstFormGroup.value.productsImageHeightMob = i;
        this.firstFormGroup.value.productsImageWidthMob = j;
        this.firstFormGroup.patchValue(this.firstFormGroup.value);
    }

    checkContains(code, form) {
        let value = this[form].value[code];
        value = value.replace(/[^0-9]/g, '')
        this[form].value[code] = value;


        this[form].patchValue(this[form].value)


    }

    displayPincode: any = [
        { "value": 1, "viewValue": "Yes" },
        { "value": 0, "viewValue": "No" },
    ]
    hideSellerAddress: any = [
        { "value": 1, "viewValue": "Yes" },
        { "value": 0, "viewValue": "No" },
    ]
    breadcrumbtype: any = [
        { "value": 0, "viewValue": "Type 1" },
        { "value": 1, "viewValue": "Type 2" },
        { "value": 2, "viewValue": "Type 3" },
        { "value": 3, "viewValue": "Type 4" },
        { "value": 4, "viewValue": "Type 5" },
        { "value": 5, "viewValue": "Type 6" },
    ]
    leadDisplaytype: any = [
        { "value": 1, "viewValue": "Type 1" },
        { "value": 2, "viewValue": "Type 2" },
        { "value": 3, "viewValue": "Type 3" },
        { "value": 4, "viewValue": "Type 4" },
        { "value": 5, "viewValue": "Type 5" },
        { "value": 6, "viewValue": "Type 6" },
        { "value": 7, "viewValue": "Type 7" },
        { "value": 8, "viewValue": "Type 8" },
        { "value": 9, "viewValue": "Type 9" },
    ]

    selectedFilter: any = null;

    onFilterChange(value: number) {
        this.selectedFilter = this.filterTypeList.find(f => f.value === value);
    }

    // filterTypeList: any = [
    //     { "value": 0, "viewValue": "Type 1" },
    //     { "value": 1, "viewValue": "Type 2" },
    //     { "value": 2, "viewValue": "Type 3" },
    //     { "value": 3, "viewValue": "Type 4" },
    //     { "value": 4, "viewValue": "Type 5" },
    //     { "value": 5, "viewValue": "Type 6" },
    //     { "value": 6, "viewValue": "Type 7" },
    //     { "value": 7, "viewValue": "Type 8" },

    // ]

    filterTypeList = [
        {
            value: 0,
            viewValue: "Type 1",
            image: "assets/filter_types/filter1.png",
            description: "Simple / Inline Filters — standard visible filters."
        },
        {
            value: 1,
            viewValue: "Type 2",
            image: "assets/filter_types/filter2.png",
            description: "Scrollable Filter Bar — filters stay in one line with horizontal scroll."
        },
        {
            value: 2,
            viewValue: "Type 3",
            image: "assets/filter_types/filter3.png",
            description: "Wrapped / Multi-line — filters wrapping to next row."
        },
        {
            value: 3,
            viewValue: "Type 4",
            image: "assets/filter_types/filter4.png",
            description: "Dropdown / Menu — a dropdown that reveals a list."
        },
        {
            value: 4,
            viewValue: "Type 5",
            image: "assets/filter_types/filter5.png",
            description: "Advanced / Attribute — complex logic and conditions."
        },
        {
            value: 5,
            viewValue: "Type 6",
            image: "assets/filter_types/filter6.png",
            description: "Sidebar / Pane — vertical filters like panels."
        },
        {
            value: 6,
            viewValue: "Type 7",
            image: "assets/filter_types/filter7.png",
            description: "Floating / Tooltip — small floating overlay filters."
        },
        {
            value: 7,
            viewValue: "Type 8",
            image: "assets/filter_types/filter8.png",
            description: "Modal / Full-Screen — full screen or popup filter workspace."
        }
    ];


    menuType: any = [
        { "value": 1, "viewValue": "Type 1" },
        { "value": 2, "viewValue": "Type 2" },
    ]



    layoutType: any = [
        { "value": 1, "viewValue": "Type 1" },
        // { "value": 2, "viewValue": "Type 2" },
        { "value": 3, "viewValue": "Type 2" },
        // { "value": 4, "viewValue": "Type 4" },
        // { "value": 5, "viewValue": "Type 5" },
        // { "value": 5, "viewValue": "Type 5" },
    ]
    technicianAssignType: any = [
        { "value": 1, "viewValue": "Manual" },
        { "value": 0, "viewValue": "Automation" },
    ]

    priceDetailType: any = [
        { "value": 0, "viewValue": "Type-1" },
        { "value": 1, "viewValue": "Type-2" },
    ]

    courseDetailPageType: any = [
        { "value": 0, "viewValue": "Type-1" },
        { "value": 1, "viewValue": "Type-2" },
    ]

    certificateDetailType: any = [
        { "value": 0, "viewValue": "Type-1" },
        { "value": 1, "viewValue": "Type-2" },
    ]

    productLayoutType: any = [
        { "value": 0, "viewValue": "Type-1" },
        { "value": 1, "viewValue": "Type-2" },
        { "value": 2, "viewValue": "Type-3" },
        { "value": 3, "viewValue": "Type-4" },
        { "value": 4, "viewValue": "Type-5" },
        { "value": 5, "viewValue": "Type-6" },
        { "value": 6, "viewValue": "Type-7" },
        { "value": 7, "viewValue": "Type-8" },
        { "value": 8, "viewValue": "Type-9" },
        { "value": 9, "viewValue": "Type-10" },
        { "value": 10, "viewValue": "Type-11" },
        { "value": 11, "viewValue": "Type-12" },
        { "value": 12, "viewValue": "Type-13" },
        { "value": 13, "viewValue": "Type-14" },
        { "value": 14, "viewValue": "Type-15" },
        { "value": 15, "viewValue": "Type-16" },
    ]

    addToCartType: any = [
        { "value": 0, "viewValue": "Type-1" },
        { "value": 1, "viewValue": "Type-2" },
        // { "value": 2, "viewValue": "Type-3" },
    ]

    categoryType: any = [
        { "value": 1, "viewValue": "Type-1" },
        { "value": 2, "viewValue": "Type-2" },
        { "value": 3, "viewValue": "Type-3" },
        { "value": 4, "viewValue": "Type-4" },
        { "value": 5, "viewValue": "Type-5" },
        { "value": 6, "viewValue": "Type-6" },
        { "value": 7, "viewValue": "Type-7" },
        { "value": 8, "viewValue": "Type-8" },
        { "value": 9, "viewValue": "Type-9" },
    ]

    checkoutPageType: any = [
        { "value": 1, "viewValue": "Type-1" },
        { "value": 2, "viewValue": "Type-2" },
    ]



    imagezoom: any = [
        { "value": 1, "viewValue": "Type-1" },
        { "value": 2, "viewValue": "Type-2" },
        { "value": 3, "viewValue": "Type-3" },
        { "value": 4, "viewValue": "Type-4" },
        { "value": 5, "viewValue": "Type-5" },
        { "value": 6, "viewValue": "Type-6" },
        { "value": 7, "viewValue": "Type-7" },
    ]

    footerLayout: any = [
        { "value": 1, "viewValue": "Type-1" },
        { "value": 2, "viewValue": "Type-2" },
        { "value": 3, "viewValue": "Type-3" },
        { "value": 4, "viewValue": "Type-4" },
        { "value": 5, "viewValue": "Type-5" },
        { "value": 6, "viewValue": "Type-6" },
        { "value": 7, "viewValue": "Type-7" },
        { "value": 8, "viewValue": "Type-8" },
        { "value": 9, "viewValue": "Type-9" },
        { "value": 10, "viewValue": "Type-10" },
        { "value": 11, "viewValue": "Type-11" },
        { "value": 12, "viewValue": "Type-12" },
        { "value": 13, "viewValue": "Customized Footer" },
    ]

    productdetails: any = [
        { "value": 1, "viewValue": "Type-1" },
        { "value": 2, "viewValue": "Type-2" },
        { "value": 3, "viewValue": "Type-3" },
        { "value": 4, "viewValue": "Type-4" },
        { "value": 5, "viewValue": "Type-5" },
        { "value": 6, "viewValue": "Type-6" },
        { "value": 7, "viewValue": "Type-7" },
        { "value": 8, "viewValue": "Type-8" },
        { "value": 9, "viewValue": "Type-9" },
        { "value": 10, "viewValue": "Type-10" },
        { "value": 11, "viewValue": "Type-11" },
        { "value": 12, "viewValue": "Type-12" },
        { "value": 13, "viewValue": "Type-13" },
        { "value": 14, "viewValue": "Type-14" },
        { "value": 15, "viewValue": "Type-15" },
        { "value": 16, "viewValue": "Type-16" },
        { "value": 17, "viewValue": "Type-17" },
        { "value": 18, "viewValue": "Type-18" },
        { "value": 19, "viewValue": "Type-19" },
        { "value": 20, "viewValue": "Type-20" },
        { "value": 21, "viewValue": "Type-21" },
    ]

    themeSecondaryColor: any = [
        { "value": 1, "viewValue": "Type-1" },
        { "value": 2, "viewValue": "Type-2" },
    ]




    getConfigProductIdNew(event, i, value, index) {
        if (event.isUserInput != false) {
            this[index] = i;

            this.firstDropDownValue.patchValue(this.configurationDropDownList[this.firstIndex].key)
            this.secondDropDownValue.patchValue(this.configurationDropDownList[this.firstIndex]
                .recursuive[this.secondIndex].key);

            this.colourCode = this.configurationDropDownList[this.firstIndex]
                .recursuive[this.secondIndex].colorCode

            //   this.configurableProductId=this.configurationDropDownList[this.firstIndex]
            //   ['recursuive'][this.secondIndex].productId;
            //   this.configProductSelected = JSON.parse(this.configProduct[this.configurableProductId]);
            //   this.setConfigProductItem();
        }
    }



    configurationDropDownList: any = [{
        "key": "red",
        "recursuive": [{
            "colorCode": "#FFCDD2",
            "key": "red100",
            "type": "light"
        }, {
            "colorCode": "#EF9A9A",
            "key": "red200",
            "type": "dark"
        }, {
            "colorCode": "#E57373",
            "key": "red300",
            "type": "dark"
        }, {
            "colorCode": "#EF5350",
            "key": "red400",
            "type": "dark"
        }, {
            "colorCode": "#F44336",
            "key": "red500",
            "type": "dark"
        }, {
            "colorCode": "#E53935",
            "key": "red600",
            "type": "dark"
        }, {
            "colorCode": "#D32F2F",
            "key": "red700",
            "type": "dark"
        }, {
            "colorCode": "#C62828",
            "key": "red800",
            "type": "dark"
        }, {
            "colorCode": "#B71C1C",
            "key": "red900",
            "type": "dark"
        }

        ]
    },
    {
        "key": "lightGreen",
        "recursuive": [{
            "colorCode": "#DCEDC8",
            "key": "lightGreen100",
            "type": "light"
        }, {
            "colorCode": "#C5E1A5",
            "key": "lightGreen200",
            "type": "dark"
        }, {
            "colorCode": "#AED581",
            "key": "lightGreen300",
            "type": "dark"
        }, {
            "colorCode": "#9CCC65",
            "key": "lightGreen400",
            "type": "dark"
        }, {
            "colorCode": "#8BC34A",
            "key": "lightGreen500",
            "type": "dark"
        }, {
            "colorCode": "#7CB342",
            "key": "lightGreen600",
            "type": "dark"
        }, {
            "colorCode": "#689F38",
            "key": "lightGreen700",
            "type": "dark"
        }, {
            "colorCode": "#558B2F",
            "key": "lightGreen800",
            "type": "dark"
        }, {
            "colorCode": "#33691E",
            "key": "lightGreen900",
            "type": "dark"
        }

        ]
    }, {
        "key": "pink",
        "recursuive": [{
            "colorCode": "#F8BBD0",
            "key": "pink100",
            "type": "light"
        }, {
            "colorCode": "#F48FB1",
            "key": "pink200",
            "type": "dark"
        }, {
            "colorCode": "#F06292",
            "key": "pink300",
            "type": "dark"
        }, {
            "colorCode": "#EC407A",
            "key": "pink400",
            "type": "dark"
        }, {
            "colorCode": "#E91E63",
            "key": "pink500",
            "type": "dark"
        }, {
            "colorCode": "#D81B60",
            "key": "pink600",
            "type": "dark"
        }, {
            "colorCode": "#C2185B",
            "key": "pink700",
            "type": "dark"
        }, {
            "colorCode": "#AD1457",
            "key": "pink800",
            "type": "dark"
        }, {
            "colorCode": "#880E4F",
            "key": "pink900",
            "type": "dark"
        }

        ]
    }, {
        "key": "gray",
        "recursuive": [{
            "colorCode": "#F5F5F5",
            "key": "gray100",
            "type": "light"
        }, {
            "colorCode": "#EEEEEE",
            "key": "gray200",
            "type": "dark"
        }, {
            "colorCode": "#E0E0E0",
            "key": "gray300",
            "type": "dark"
        }, {
            "colorCode": "#BDBDBD",
            "key": "gray400",
            "type": "dark"
        }, {
            "colorCode": "#9E9E9E",
            "key": "gray500",
            "type": "dark"
        }, {
            "colorCode": "#757575",
            "key": "gray600",
            "type": "dark"
        }, {
            "colorCode": "#616161",
            "key": "gray700",
            "type": "dark"
        }, {
            "colorCode": "#424242",
            "key": "gray800",
            "type": "dark"
        }, {
            "colorCode": "#212121",
            "key": "gray900",
            "type": "dark"
        }

        ]
    }, {
        "key": "orange",
        "recursuive": [{
            "colorCode": "#FFE0B2",
            "key": "orange100",
            "type": "light"
        }, {
            "colorCode": "#FFCC80",
            "key": "orange200",
            "type": "dark"
        }, {
            "colorCode": "#FFB74D",
            "key": "orange300",
            "type": "dark"
        }, {
            "colorCode": "#FFA726",
            "key": "orange400",
            "type": "dark"
        }, {
            "colorCode": "#FF9800",
            "key": "orange500",
            "type": "dark"
        }, {
            "colorCode": "#FB8C00",
            "key": "orange600",
            "type": "dark"
        }, {
            "colorCode": "#F57C00",
            "key": "orange700",
            "type": "dark"
        }, {
            "colorCode": "#EF6C00",
            "key": "orange800",
            "type": "dark"
        }, {
            "colorCode": "#E65100",
            "key": "orange900",
            "type": "dark"
        }

        ]
    }, {
        "key": "green",
        "recursuive": [{
            "colorCode": "#C8E6C9",
            "key": "green100",
            "type": "light"
        }, {
            "colorCode": "#A5D6A7",
            "key": "green200",
            "type": "dark"
        }, {
            "colorCode": "#81C784",
            "key": "green300",
            "type": "dark"
        }, {
            "colorCode": "#66BB6A",
            "key": "green400",
            "type": "dark"
        }, {
            "colorCode": "#4CAF50",
            "key": "green500",
            "type": "dark"
        }, {
            "colorCode": "#43A047",
            "key": "green600",
            "type": "dark"
        }, {
            "colorCode": "#388E3C",
            "key": "green700",
            "type": "dark"
        }, {
            "colorCode": "#2E7D32",
            "key": "green800",
            "type": "dark"
        }, {
            "colorCode": "#1B5E20",
            "key": "green900",
            "type": "dark"
        }

        ]
    }, {
        "key": "blue",
        "recursuive": [{
            "colorCode": "#BBDEFB",
            "key": "blue100",
            "type": "light"
        }, {
            "colorCode": "#90CAF9",
            "key": "blue200",
            "type": "dark"
        }, {
            "colorCode": "#64B5F6",
            "key": "blue300",
            "type": "dark"
        }, {
            "colorCode": "#42A5F5",
            "key": "blue400",
            "type": "dark"
        }, {
            "colorCode": "#2196F3",
            "key": "blue500",
            "type": "dark"
        }, {
            "colorCode": "#1E88E5",
            "key": "blue600",
            "type": "dark"
        }, {
            "colorCode": "#1976D2",
            "key": "blue700",
            "type": "dark"
        }, {
            "colorCode": "#1565C0",
            "key": "blue800",
            "type": "dark"
        }, {
            "colorCode": "#0D47A1",
            "key": "blue900",
            "type": "dark"
        }

        ]
    }, {
        "key": "indigo",
        "recursuive": [{
            "colorCode": "#C5CAE9",
            "key": "indigo100",
            "type": "light"
        }, {
            "colorCode": "#9FA8DA",
            "key": "indigo200",
            "type": "dark"
        }, {
            "colorCode": "#7986CB",
            "key": "indigo300",
            "type": "dark"
        }, {
            "colorCode": "#5C6BC0",
            "key": "indigo400",
            "type": "dark"
        }, {
            "colorCode": "#3F51B5",
            "key": "indigo500",
            "type": "dark"
        }, {
            "colorCode": "#3949AB",
            "key": "indigo600",
            "type": "dark"
        }, {
            "colorCode": "#303F9F",
            "key": "indigo700",
            "type": "dark"
        }, {
            "colorCode": "#283593",
            "key": "indigo800",
            "type": "dark"
        }, {
            "colorCode": "#1A237E",
            "key": "indigo900",
            "type": "dark"
        }

        ]
    }, {
        "key": "teal",
        "recursuive": [{
            "colorCode": "#B2DFDB",
            "key": "teal100",
            "type": "light"
        }, {
            "colorCode": "#80CBC4",
            "key": "teal200",
            "type": "dark"
        }, {
            "colorCode": "#4DB6AC",
            "key": "teal300",
            "type": "dark"
        }, {
            "colorCode": "#26A69A",
            "key": "teal400",
            "type": "dark"
        }, {
            "colorCode": "#009688",
            "key": "teal500",
            "type": "dark"
        }, {
            "colorCode": "#00897B",
            "key": "teal600",
            "type": "dark"
        }, {
            "colorCode": "#00796B",
            "key": "teal700",
            "type": "dark"
        }, {
            "colorCode": "#00695C",
            "key": "teal800",
            "type": "dark"
        }, {
            "colorCode": "#004D40",
            "key": "teal900",
            "type": "dark"
        }

        ]
    }, {
        "key": "lime",
        "recursuive": [{
            "colorCode": "#F0F4C3",
            "key": "lime100",
            "type": "light"
        }, {
            "colorCode": "#E6EE9C",
            "key": "lime200",
            "type": "dark"
        }, {
            "colorCode": "#DCE775",
            "key": "lime300",
            "type": "dark"
        }, {
            "colorCode": "#D4E157",
            "key": "lime400",
            "type": "dark"
        }, {
            "colorCode": "#CDDC39",
            "key": "lime500",
            "type": "dark"
        }, {
            "colorCode": "#C0CA33",
            "key": "lime600",
            "type": "dark"
        }, {
            "colorCode": "#AFB42B",
            "key": "lime700",
            "type": "dark"
        }, {
            "colorCode": "#9E9D24",
            "key": "lime800",
            "type": "dark"
        }, {
            "colorCode": "#827717",
            "key": "lime900",
            "type": "dark"
        }

        ]
    }, {
        "key": "yellow",
        "recursuive": [{
            "colorCode": "#FFF9C4",
            "key": "yellow100",
            "type": "light"
        }, {
            "colorCode": "#FFF59D",
            "key": "yellow200",
            "type": "dark"
        }, {
            "colorCode": "#FFF176",
            "key": "yellow300",
            "type": "dark"
        }, {
            "colorCode": "#FFEE58",
            "key": "yellow400",
            "type": "dark"
        }, {
            "colorCode": "#FFEB3B",
            "key": "yellow500",
            "type": "dark"
        }, {
            "colorCode": "#FDD835",
            "key": "yellow600",
            "type": "dark"
        }, {
            "colorCode": "#FBC02D",
            "key": "yellow700",
            "type": "dark"
        }, {
            "colorCode": "#F9A825",
            "key": "yellow800",
            "type": "dark"
        }, {
            "colorCode": "#F57F17",
            "key": "yellow900",
            "type": "dark"
        }

        ]
    }, {
        "key": "amber",
        "recursuive": [{
            "colorCode": "#FFECB3",
            "key": "amber100",
            "type": "light"
        }, {
            "colorCode": "#FFE082",
            "key": "amber200",
            "type": "dark"
        }, {
            "colorCode": "#FFD54F",
            "key": "amber300",
            "type": "dark"
        }, {
            "colorCode": "#FFCA28",
            "key": "amber400",
            "type": "dark"
        }, {
            "colorCode": "#FFC107",
            "key": "amber500",
            "type": "dark"
        }, {
            "colorCode": "#FFB300",
            "key": "amber600",
            "type": "dark"
        }, {
            "colorCode": "#FFA000",
            "key": "amber700",
            "type": "dark"
        }, {
            "colorCode": "#FF8F00",
            "key": "amber800",
            "type": "dark"
        }, {
            "colorCode": "#FF6F00",
            "key": "amber900",
            "type": "dark"
        }

        ]
    }, {
        "key": "lightblue",
        "recursuive": [{
            "colorCode": "#B3E5FC",
            "key": "lightblue100",
            "type": "light"
        }, {
            "colorCode": "#81D4FA",
            "key": "lightblue200",
            "type": "dark"
        }, {
            "colorCode": "#4FC3F7",
            "key": "lightblue300",
            "type": "dark"
        }, {
            "colorCode": "#29B6F6",
            "key": "lightblue400",
            "type": "dark"
        }, {
            "colorCode": "#03A9F4",
            "key": "lightblue500",
            "type": "dark"
        }, {
            "colorCode": "#039BE5",
            "key": "lightblue600",
            "type": "dark"
        }, {
            "colorCode": "#0288D1",
            "key": "lightblue700",
            "type": "dark"
        }, {
            "colorCode": "#0277BD",
            "key": "lightblue800",
            "type": "dark"
        }, {
            "colorCode": "#01579B",
            "key": "lightblue900",
            "type": "dark"
        }

        ]
    }, {
        "key": "deeporange",
        "recursuive": [{
            "colorCode": "#FFCCBC",
            "key": "deeporange100",
            "type": "light"
        }, {
            "colorCode": "#FFAB91",
            "key": "deeporange200",
            "type": "dark"
        }, {
            "colorCode": "#FF8A65",
            "key": "deeporange300",
            "type": "dark"
        }, {
            "colorCode": "#FF7043",
            "key": "deeporange400",
            "type": "dark"
        }, {
            "colorCode": "#FF5722",
            "key": "deeporange500",
            "type": "dark"
        }, {
            "colorCode": "#F4511E",
            "key": "deeporange600",
            "type": "dark"
        }, {
            "colorCode": "#E64A19",
            "key": "deeporange700",
            "type": "dark"
        }, {
            "colorCode": "#D84315",
            "key": "deeporange800",
            "type": "dark"
        }, {
            "colorCode": "#BF360C",
            "key": "deeporange900",
            "type": "dark"
        }

        ]
    }, {
        "key": "bluegray",
        "recursuive": [{
            "colorCode": "#CFD8DC",
            "key": "bluegray100",
            "type": "light"
        }, {
            "colorCode": "#B0BEC5",
            "key": "bluegray200",
            "type": "dark"
        }, {
            "colorCode": "#90A4AE",
            "key": "bluegray300",
            "type": "dark"
        }, {
            "colorCode": "#78909C",
            "key": "bluegray400",
            "type": "dark"
        }, {
            "colorCode": "#607D8B",
            "key": "bluegray500",
            "type": "dark"
        }, {
            "colorCode": "#546E7A",
            "key": "bluegray600",
            "type": "dark"
        }, {
            "colorCode": "#455A64",
            "key": "bluegray700",
            "type": "dark"
        }, {
            "colorCode": "#37474F",
            "key": "bluegray800",
            "type": "dark"
        }, {
            "colorCode": "#263238",
            "key": "bluegray900",
            "type": "dark"
        }

        ]
    }, {
        "key": "brown",
        "recursuive": [{
            "colorCode": "#D7CCC8",
            "key": "brown100",
            "type": "light"
        }, {
            "colorCode": "#BCAAA4",
            "key": "brown200",
            "type": "dark"
        }, {
            "colorCode": "#A1887F",
            "key": "brown300",
            "type": "dark"
        }, {
            "colorCode": "#8D6E63",
            "key": "brown400",
            "type": "dark"
        }, {
            "colorCode": "#795548",
            "key": "brown500",
            "type": "dark"
        }, {
            "colorCode": "#6D4C41",
            "key": "brown600",
            "type": "dark"
        }, {
            "colorCode": "#5D4037",
            "key": "brown700",
            "type": "dark"
        }, {
            "colorCode": "#4E342E",
            "key": "brown800",
            "type": "dark"
        }, {
            "colorCode": "#3E2723",
            "key": "brown900",
            "type": "dark"
        }

        ]
    }, {
        "key": "deeppurple",
        "recursuive": [{
            "colorCode": "#D1C4E9",
            "key": "deeppurple100",
            "type": "light"
        }, {
            "colorCode": "#B39DDB",
            "key": "deeppurple200",
            "type": "dark"
        }, {
            "colorCode": "#9575CD",
            "key": "deeppurple300",
            "type": "dark"
        }, {
            "colorCode": "#7E57C2",
            "key": "deeppurple400",
            "type": "dark"
        }, {
            "colorCode": "#673AB7",
            "key": "deeppurple500",
            "type": "dark"
        }, {
            "colorCode": "#5E35B1",
            "key": "deeppurple600",
            "type": "dark"
        }, {
            "colorCode": "#512DA8",
            "key": "deeppurple700",
            "type": "dark"
        }, {
            "colorCode": "#4527A0",
            "key": "deeppurple800",
            "type": "dark"
        }, {
            "colorCode": "#311B92",
            "key": "deeppurple900",
            "type": "dark"
        }

        ]
    }, {
        "key": "purple",
        "recursuive": [{
            "colorCode": "#E1BEE7",
            "key": "purple100",
            "type": "light"
        }, {
            "colorCode": "#CE93D8",
            "key": "purple200",
            "type": "dark"
        }, {
            "colorCode": "#BA68C8",
            "key": "purple300",
            "type": "dark"
        }, {
            "colorCode": "#AB47BC",
            "key": "purple400",
            "type": "dark"
        }, {
            "colorCode": "#9C27B0",
            "key": "purple500",
            "type": "dark"
        }, {
            "colorCode": "#8E24AA",
            "key": "purple600",
            "type": "dark"
        }, {
            "colorCode": "#7B1FA2",
            "key": "purple700",
            "type": "dark"
        }, {
            "colorCode": "#6A1B9A",
            "key": "purple800",
            "type": "dark"
        }, {
            "colorCode": "#4A148C",
            "key": "purple900",
            "type": "dark"
        }

        ]
    }, {
        "key": "cyan",
        "recursuive": [{
            "colorCode": "#B2EBF2",
            "key": "cyan100",
            "type": "light"
        }, {
            "colorCode": "#80DEEA",
            "key": "cyan200",
            "type": "dark"
        }, {
            "colorCode": "#4DD0E1",
            "key": "cyan300",
            "type": "dark"
        }, {
            "colorCode": "#26C6DA",
            "key": "cyan400",
            "type": "dark"
        }, {
            "colorCode": "#00BCD4",
            "key": "cyan500",
            "type": "dark"
        }, {
            "colorCode": "#00ACC1",
            "key": "cyan600",
            "type": "dark"
        }, {
            "colorCode": "#0097A7",
            "key": "cyan700",
            "type": "dark"
        }, {
            "colorCode": "#00838F",
            "key": "cyan800",
            "type": "dark"
        }, {
            "colorCode": "#006064",
            "key": "cyan900",
            "type": "dark"
        }

        ]
    }

    ]

    RestrictionDialog() {
        let dialogRef = this.dialog.open(RestrictionComponent, {
            width: '350px',
            disableClose: false,
        });
        dialogRef.disableClose = false;
    }

    //logo impl
    // imageVisible: any = true;
    imagesToRemoved: any = [];
    //  imageDelete: boolean=false;

    imagesToRemoved1: any = [];

    imageVisible: any = true;
    imageVisible1: any = true;
    imageVisible2: any = true;
    imageVisible3: any = true;
    imageVisible4: any = true;
    imageVisible5: any = true;
    imageVisible6: any = true;
    imageVisible7: any = true;
    imageVisible8: any = true;
    imageVisible9: any = true;
    imageVisible10: any = true;
    imageVisible11: any = true;
    imageVisible12: any = true;
    imageVisible13: any = true;

    imageDelete: boolean = false;
    imageDelete1: boolean = false;
    imageDelete2: boolean = false;
    imageDelete3: boolean = false;
    imageDelete4: boolean = false;
    imageDelete5: boolean = false;
    imageDelete6: boolean = false;
    imageDelete7: boolean = false;
    imageDelete8: boolean = false;
    imageDelete9: boolean = false;
    imageDelete10: boolean = false;
    imageDelete11: boolean = false;
    imageDelete12: boolean = false;
    imageDelete13: boolean = false;

    path: string;
    path1: string;
    path4: string;
    path7: string;
    path10: string;
    path11: string;
    path12: string;
    path13: string;

    public serverPath1 = environment.commonImageApi + "footerImage/";

    public serverPath2 = environment.commonImageApi + "headerImage/";

    public serverPath3 = environment.commonImageApi + "mobileImage/";

    public serverPath4 = environment.commonImageApi + "favImage/";

    public serverPath5 = environment.commonImageApi + "homePageBackgroundImgSrc/";

    public serverPath6 = environment.commonImageApi + "adsHomePageImage/";

    public serverPath7 = environment.commonImageApi + "footerBrands/";

    public serverPath8 = environment.commonImageApi + "footerBackground/";

    public serverPath9 = environment.commonImageApi + "certificateBackgroundImg/";

    public serverPath10 = environment.commonImageApi + "courseManagerSign/";

    public serverPath11 = environment.commonImageApi + "deliveryIconImage/";

    public serverPath12 = environment.commonImageApi + "categoryPageImageLayout/";

    public serverPath13 = environment.commonImageApi + "LogoWaterMarkImage/";

    public serverPath14 = environment.commonImageApi + "browerMediaImage/";

    logo1() {
        this.imageVisible = false;
    }

    logo2() {
        this.imageVisible1 = false;
    }

    logo3() {
        this.imageVisible2 = false;
    }

    logo4() {
        this.imageVisible3 = false;
    }

    logo5() {
        this.imageVisible4 = false;
    }

    logo6() {
        this.imageVisible5 = false;
    }

    logo7() {
        this.imageVisible6 = false;
    }

    logo8() {
        this.imageVisible7 = false;
    }

    logo9() {
        this.imageVisible8 = false;
    }

    logo10() {
        this.imageVisible9 = false;
    }

    logo11() {
        this.imageVisible11 = false;
    }

    logo12() {
        this.imageVisible12 = false;
    }

    logo13() {
        this.imageVisible13 = false;
    }


    getIamge(event) {


        this.firstFormGroup.value.footerLogoSrc = event['productEntityMediaGallery'][0].fileName;

        console.log(this.firstFormGroup)

        this.firstFormGroup.patchValue(this.firstFormGroup.value);

        this.imageVisible = true;
        this.imageDelete = true;

        this.path = this.serverPath1 + this.firstFormGroup.value.footerLogoSrc;

        this.snackBar.open("Image Uploaded Successfully..", '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
    }


    getIamge1(event) {


        this.firstFormGroup.value.headerLogoSrc = event['productEntityMediaGallery'][0].fileName;

        this.firstFormGroup.patchValue(this.firstFormGroup.value);

        this.imageVisible1 = true;
        this.imageDelete1 = true;

        this.path1 = this.serverPath2 + this.firstFormGroup.value.headerLogoSrc;

        this.snackBar.open("Image Uploaded Successfully..", '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
    }

    getIamge2(event) {


        this.firstFormGroup.value.mobileLogoSrc = event['productEntityMediaGallery'][0].fileName;

        this.firstFormGroup.patchValue(this.firstFormGroup.value);

        this.imageVisible2 = true;
        this.imageDelete2 = true;

        this.path2 = this.serverPath3 + this.firstFormGroup.value.mobileLogoSrc;

        this.snackBar.open("Image Uploaded Successfully..", '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
    }

    getIamge3(event) {


        this.firstFormGroup.value.faviconSrc = event['productEntityMediaGallery'][0].fileName;

        this.firstFormGroup.patchValue(this.firstFormGroup.value);

        this.imageVisible3 = true;
        this.imageDelete3 = true;

        this.path3 = this.serverPath4 + this.firstFormGroup.value.faviconSrc;

        this.snackBar.open("Image Uploaded Successfully..", '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
    }

    getIamge4(event) {


        this.firstFormGroup.value.homePageBackgroundImgSrc = event['productEntityMediaGallery'][0].fileName;

        this.firstFormGroup.patchValue(this.firstFormGroup.value);

        this.imageVisible4 = true;
        this.imageDelete4 = true;

        this.path4 = this.serverPath5 + this.firstFormGroup.value.homePageBackgroundImgSrc;

        this.snackBar.open("Image Uploaded Successfully..", '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
    }

    getIamge5(event) {


        this.firstFormGroup.value.adsHomePageImage = event['productEntityMediaGallery'][0].fileName;

        this.firstFormGroup.patchValue(this.firstFormGroup.value);

        this.imageVisible5 = true;
        this.imageDelete5 = true;

        this.path5 = this.serverPath6 + this.firstFormGroup.value.adsHomePageImage;

        this.snackBar.open("Image Uploaded Successfully..", '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
    }

    getIamge6(event) {


        this.firstFormGroup.value.footerBrandImg = event['productEntityMediaGallery'][0].fileName;

        this.firstFormGroup.patchValue(this.firstFormGroup.value);

        this.imageVisible6 = true;
        this.imageDelete6 = true;

        this.path6 = this.serverPath7 + this.firstFormGroup.value.footerBrandImg;

        this.snackBar.open("Image Uploaded Successfully..", '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
    }

    getIamge7(event) {


        this.firstFormGroup.value.footerBackgroundImg = event['productEntityMediaGallery'][0].fileName;

        this.firstFormGroup.patchValue(this.firstFormGroup.value);

        this.imageVisible7 = true;
        this.imageDelete7 = true;

        this.path7 = this.serverPath8 + this.firstFormGroup.value.footerBackgroundImg;

        this.snackBar.open("Image Uploaded Successfully..", '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
    }

    getIamge8(event) {


        this.firstFormGroup.value.certificateBackgroundImg = event['productEntityMediaGallery'][0].fileName;

        this.firstFormGroup.patchValue(this.firstFormGroup.value);

        this.imageVisible8 = true;
        this.imageDelete8 = true;

        this.path8 = this.serverPath9 + this.firstFormGroup.value.certificateBackgroundImg;

        this.snackBar.open("Image Uploaded Successfully..", '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
    }

    getIamge9(event) {


        this.firstFormGroup.value.courseManagerSign = event['productEntityMediaGallery'][0].fileName;

        this.firstFormGroup.patchValue(this.firstFormGroup.value);

        this.imageVisible9 = true;
        this.imageDelete9 = true;

        this.path9 = this.serverPath10 + this.firstFormGroup.value.courseManagerSign;

        this.snackBar.open("Image Uploaded Successfully..", '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
    }

    getIamge10(event) {


        this.firstFormGroup.value.deliveryIconImage = event['productEntityMediaGallery'][0].fileName;

        this.firstFormGroup.patchValue(this.firstFormGroup.value);

        this.imageVisible1 = true;
        this.imageDelete1 = true;

        this.path10 = this.serverPath11 + this.firstFormGroup.value.deliveryIconImage;

        this.snackBar.open("Image Uploaded Successfully..", '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
    }


    getIamge11(event) {


        this.firstFormGroup.value.deliveryIconImage = event['productEntityMediaGallery'][0].fileName;

        this.firstFormGroup.patchValue(this.firstFormGroup.value);

        this.imageVisible10 = true;
        this.imageDelete10 = true;

        this.path10 = this.serverPath11 + this.firstFormGroup.value.deliveryIconImage;

        this.snackBar.open("Image Uploaded Successfully..", '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
    }


    getIamge12(event) {


        this.firstFormGroup.value.categoryPageImageLayout = event['productEntityMediaGallery'][0].fileName;

        this.firstFormGroup.patchValue(this.firstFormGroup.value);

        this.imageVisible11 = true;
        this.imageDelete11 = true;

        this.path11 = this.serverPath12 + this.firstFormGroup.value.categoryPageImageLayout;

        this.snackBar.open("Image Uploaded Successfully..", '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
    }

    getIamge13(event) {


        this.firstFormGroup.value.logoWaterMark = event['productEntityMediaGallery'][0].fileName;

        console.log(this.firstFormGroup)

        this.firstFormGroup.patchValue(this.firstFormGroup.value);

        this.imageVisible12 = true;
        this.imageDelete12 = true;

        this.path12 = this.serverPath13 + this.firstFormGroup.value.logoWaterMark;

        this.snackBar.open("Image Uploaded Successfully..", '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
    }

    getIamge14(event) {


        this.firstFormGroup.value.browserGraphImage = event['productEntityMediaGallery'][0].fileName;

        console.log(this.firstFormGroup)

        this.firstFormGroup.patchValue(this.firstFormGroup.value);

        this.imageVisible13 = true;
        this.imageDelete13 = true;

        this.path13 = this.serverPath14 + this.firstFormGroup.value.browserGraphImage;

        this.snackBar.open("Image Uploaded Successfully..", '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
    }

    deleteImage2() {
        this.imageVisible1 = false;
        this.imageDelete1 = true;
        let smallImage = "/headerImage/" + this.firstFormGroup.value.headerLogoSrc;
        this.imagesToRemoved1.push(smallImage);
        this.productService.deleteImage(this.imagesToRemoved1).subscribe(
            (response) => {
                if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
                    this.firstFormGroup.value.image = '';
                    this.firstFormGroup.patchValue(this.firstFormGroup.value)
                    this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
                    this.text = "Save"
                    this.imageVisible1 = true;
                    this.imageDelete1 = false;
                    this.path = "assets/images/logo/no-image.png";
                }
                else {
                    this.imageVisible1 = true;
                    this.imageDelete1 = false;

                    this.text = "Save"
                    this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
                }
            },
            (err) => {
                this.imageVisible1 = true;
            });

    }

    deleteImage3() {
        this.imageVisible2 = false;
        this.imageDelete2 = true;
        let smallImage = "/mobileImage/" + this.firstFormGroup.value.mobileLogoSrc;
        this.imagesToRemoved.push(smallImage);
        this.productService.deleteImage(this.imagesToRemoved).subscribe(
            (response) => {
                if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
                    this.firstFormGroup.value.image = '';
                    this.firstFormGroup.patchValue(this.firstFormGroup.value)
                    this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
                    this.text = "Save"
                    this.imageVisible2 = true;
                    this.imageDelete2 = false;
                    this.path = "assets/images/logo/no-image.png";

                    //TO make empty while deleting 
                    this.firstFormGroup.patchValue({ mobileLogoSrc: '' });


                }
                else {
                    this.imageVisible2 = true;
                    this.imageDelete2 = false;

                    this.text = "Save"
                    this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
                }
            },
            (err) => {
                this.imageVisible2 = true;
            });


    }

    deleteImage4() {
        this.imageVisible3 = false;
        this.imageDelete3 = true;
        let smallImage = "/favImage/" + this.firstFormGroup.value.faviconSrc;
        this.imagesToRemoved.push(smallImage);
        this.productService.deleteImage(this.imagesToRemoved).subscribe(
            (response) => {
                if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
                    this.firstFormGroup.value.image = '';
                    this.firstFormGroup.patchValue(this.firstFormGroup.value)
                    this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
                    this.text = "Save"
                    this.imageVisible3 = true;
                    this.imageDelete3 = false;
                    this.path = "assets/images/logo/no-image.png";
                }
                else {
                    this.imageVisible3 = true;
                    this.imageDelete3 = false;

                    this.text = "Save"
                    this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
                }
            },
            (err) => {
                this.imageVisible3 = true;
            });

    }

    deleteImage5() {
        this.imageVisible4 = false;
        this.imageDelete4 = true;
        let smallImage = "/homePageBackgroundImgSrc/" + this.firstFormGroup.value.homePageBackgroundImgSrc;
        this.imagesToRemoved.push(smallImage);
        this.productService.deleteImage(this.imagesToRemoved).subscribe(
            (response) => {
                if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
                    this.firstFormGroup.value.image = '';
                    this.firstFormGroup.patchValue(this.firstFormGroup.value)
                    this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
                    this.text = "Save"
                    this.imageVisible4 = true;
                    this.imageDelete4 = false;
                    this.path = "assets/images/logo/no-image.png";
                }
                else {
                    this.imageVisible4 = true;
                    this.imageDelete4 = false;

                    this.text = "Save"
                    this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
                }
            },
            (err) => {
                this.imageVisible4 = true;
            });

    }

    deleteImage6() {
        this.imageVisible5 = false;
        this.imageDelete5 = true;
        let smallImage = "/adsHomePageImage/" + this.firstFormGroup.value.adsHomePageImage;
        this.imagesToRemoved.push(smallImage);
        this.productService.deleteImage(this.imagesToRemoved).subscribe(
            (response) => {
                if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
                    this.firstFormGroup.value.image = '';
                    this.firstFormGroup.patchValue(this.firstFormGroup.value)
                    this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
                    this.text = "Save"
                    this.imageVisible5 = true;
                    this.imageDelete5 = false;
                    this.path = "assets/images/logo/no-image.png";
                }
                else {
                    this.imageVisible5 = true;
                    this.imageDelete5 = false;

                    this.text = "Save"
                    this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
                }
            },
            (err) => {
                this.imageVisible5 = true;
            });

    }

    deleteImage7() {
        this.imageVisible6 = false;
        this.imageDelete6 = true;
        let smallImage = "/footerBrands/" + this.firstFormGroup.value.footerBrandImg;
        this.imagesToRemoved.push(smallImage);
        this.productService.deleteImage(this.imagesToRemoved).subscribe(
            (response) => {
                if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
                    this.firstFormGroup.value.image = '';
                    this.firstFormGroup.patchValue(this.firstFormGroup.value)
                    this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
                    this.text = "Save"
                    this.imageVisible6 = true;
                    this.imageDelete6 = false;
                    this.path = "assets/images/logo/no-image.png";
                }
                else {
                    this.imageVisible6 = true;
                    this.imageDelete6 = false;

                    this.text = "Save"
                    this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
                }
            },
            (err) => {
                this.imageVisible6 = true;
            });

    }

    deleteImage8() {
        this.imageVisible7 = false;
        this.imageDelete7 = true;
        let smallImage = "/footerBackground/" + this.firstFormGroup.value.footerBackgroundImg;
        this.imagesToRemoved.push(smallImage);
        this.productService.deleteImage(this.imagesToRemoved).subscribe(
            (response) => {
                if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
                    this.firstFormGroup.value.image = '';
                    this.firstFormGroup.patchValue(this.firstFormGroup.value)
                    this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
                    this.text = "Save"
                    this.imageVisible7 = true;
                    this.imageDelete7 = false;
                    this.path = "assets/images/logo/no-image.png";
                }
                else {
                    this.imageVisible7 = true;
                    this.imageDelete7 = false;

                    this.text = "Save"
                    this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
                }
            },
            (err) => {
                this.imageVisible7 = true;
            });

    }

    deleteImage1() {
        this.imageVisible = false;
        this.imageDelete = true;
        let smallImage = "/footerImage/" + this.firstFormGroup.value.footerLogoSrc;
        this.imagesToRemoved.push(smallImage);
        this.productService.deleteImage(this.imagesToRemoved).subscribe(
            (response) => {
                if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
                    this.firstFormGroup.value.image = '';
                    this.firstFormGroup.patchValue(this.firstFormGroup.value)
                    this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
                    this.text = "Save"
                    this.imageVisible = true;
                    this.imageDelete = false;
                    this.path = "assets/images/logo/no-image.png";
                }
                else {
                    this.imageVisible = true;
                    this.imageDelete = false;

                    this.text = "Save"
                    this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
                }
            },
            (err) => {
                this.imageVisible = true;
            });

    }

    deleteImage9() {
        this.imageVisible8 = false;
        this.imageDelete8 = true;
        let smallImage = "/certificateBackgroundImg/" + this.firstFormGroup.value.certificateBackgroundImg;
        this.imagesToRemoved.push(smallImage);
        this.productService.deleteImage(this.imagesToRemoved).subscribe(
            (response) => {
                if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
                    this.firstFormGroup.value.image = '';
                    this.firstFormGroup.patchValue(this.firstFormGroup.value)
                    this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
                    this.text = "Save"
                    this.imageVisible8 = true;
                    this.imageDelete8 = false;
                    this.path = "assets/images/logo/no-image.png";
                }
                else {
                    this.imageVisible8 = true;
                    this.imageDelete8 = false;

                    this.text = "Save"
                    this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
                }
            },
            (err) => {
                this.imageVisible8 = true;
            });

    }

    deleteImage10() {
        this.imageVisible9 = false;
        this.imageDelete9 = true;
        let smallImage = "/courseManagerSign/" + this.firstFormGroup.value.courseManagerSign;
        this.imagesToRemoved.push(smallImage);
        this.productService.deleteImage(this.imagesToRemoved).subscribe(
            (response) => {
                if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
                    this.firstFormGroup.value.image = '';
                    this.firstFormGroup.patchValue(this.firstFormGroup.value)
                    this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
                    this.text = "Save"
                    this.imageVisible9 = true;
                    this.imageDelete9 = false;
                    this.path = "assets/images/logo/no-image.png";
                }
                else {
                    this.imageVisible9 = true;
                    this.imageDelete9 = false;

                    this.text = "Save"
                    this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
                }
            },
            (err) => {
                this.imageVisible9 = true;
            });

    }


    deleteImag11() {
        this.imageVisible10 = false;
        this.imageDelete10 = true;
        let smallImage = "/deliveryIconImage/" + this.firstFormGroup.value.deliveryIconImage;
        this.imagesToRemoved1.push(smallImage);
        this.productService.deleteImage(this.imagesToRemoved1).subscribe(
            (response) => {
                if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
                    this.firstFormGroup.value.image = '';
                    this.firstFormGroup.patchValue(this.firstFormGroup.value)
                    this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
                    this.text = "Save"
                    this.imageVisible10 = true;
                    this.imageDelete10 = false;
                    this.path10 = "assets/images/logo/no-image.png";
                }
                else {
                    this.imageVisible10 = true;
                    this.imageDelete10 = false;

                    this.text = "Save"
                    this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
                }
            },
            (err) => {
                this.imageVisible10 = true;
            });

    }

    deleteImage12() {
        this.imageVisible11 = false;
        this.imageDelete11 = true;
        let smallImage = "/categoryPageImageLayout/" + this.firstFormGroup.value.categoryPageImageLayout;
        this.imagesToRemoved1.push(smallImage);
        this.productService.deleteImage(this.imagesToRemoved1).subscribe(
            (response) => {
                if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
                    this.firstFormGroup.value.image = '';
                    this.firstFormGroup.patchValue(this.firstFormGroup.value)
                    this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
                    this.text = "Save"
                    this.imageVisible11 = true;
                    this.imageDelete11 = false;
                    this.path = "assets/images/logo/no-image.png";
                }
                else {
                    this.imageVisible11 = true;
                    this.imageDelete11 = false;

                    this.text = "Save"
                    this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
                }
            },
            (err) => {
                this.imageVisible11 = true;
            });

    }

    deleteImage13() {
        this.imageVisible12 = false;
        this.imageDelete12 = true;
        let smallImage = "/LogoWaterMarkImage/" + this.firstFormGroup.value.logoWaterMark;
        this.imagesToRemoved.push(smallImage);
        this.productService.deleteImage(this.imagesToRemoved).subscribe(
            (response) => {
                if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
                    this.firstFormGroup.value.image = '';
                    this.firstFormGroup.patchValue(this.firstFormGroup.value)
                    this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
                    this.text = "Save"
                    this.imageVisible12 = true;
                    this.imageDelete12 = false;
                    this.path = "assets/images/logo/no-image.png";
                }
                else {
                    this.imageVisible12 = true;
                    this.imageDelete12 = false;

                    this.text = "Save"
                    this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
                }
            },
            (err) => {
                this.imageVisible12 = true;
            });

    }

    deleteImage14() {
        this.imageVisible13 = false;
        this.imageDelete13 = true;
        let smallImage = "/browerMediaImage/" + this.firstFormGroup.value.browserGraphImage;
        this.imagesToRemoved.push(smallImage);
        this.productService.deleteImage(this.imagesToRemoved).subscribe(
            (response) => {
                if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
                    this.firstFormGroup.value.browserGraphImage = '';
                    this.firstFormGroup.patchValue(this.firstFormGroup.value)
                    this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
                    this.text = "Save"
                    this.imageVisible13 = true;
                    this.imageDelete13 = false;
                    this.path = "assets/images/logo/no-image.png";
                }
                else {
                    this.imageVisible13 = true;
                    this.imageDelete13 = false;

                    this.text = "Save"
                    this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
                }
            },
            (err) => {
                this.imageVisible13 = true;
            });

    }


    cancel1() {

        this.imageVisible = true;

    }

    cancel5() {

        this.imageVisible4 = true;

    }

    cancel2() {

        this.imageVisible1 = true;

    }
    cancel3() {

        this.imageVisible2 = true;

    }
    cancel4() {

        this.imageVisible3 = true;

    }

    cancel6() {

        this.imageVisible5 = true;

    }

    cancel7() {

        this.imageVisible6 = true;

    }

    cancel8() {

        this.imageVisible7 = true;

    }

    cancel9() {

        this.imageVisible8 = true;

    }

    cancel10() {

        this.imageVisible9 = true;

    }

    cancel11() {

        this.imageVisible10 = true;

    }

    cancel12() {

        this.imageVisible11 = true;

    }

    cancel13() {

        this.imageVisible12 = true;

    }

    cancel14() {

        this.imageVisible13 = true;

    }


    //contact form

    dynamicFormTypeList: any;
    filtereddynamicFormTypeList: any;

    public dynamicFormFilterControl: UntypedFormControl = new UntypedFormControl();

    dynamicFormList: any;
    getdynamicFormList() {
        this.dynamicFormGroupService.getAllDynmaicFormDropDown(1).subscribe(
            (res) => {
                this.dynamicFormList = res;
                this.dynamicFormTypeList = this.dynamicFormList;
                this.filtereddynamicFormTypeList = this.dynamicFormTypeList;
            },
            (error) => { }
        );
    }

    dynmaicFormYFilter() {
        this.dynamicFormFilterControl.valueChanges
            .pipe(takeUntil(this._onDestroy))
            .subscribe(() => {
                this.dynamicFilter();
            });
    }

    protected dynamicFilter() {
        if (!this.dynamicFormTypeList) {
            return;
        }
        let search = this.dynamicFormFilterControl.value;
        if (!search) {
            this.filtereddynamicFormTypeList = this.dynamicFormTypeList.slice();
            return;
        } else {
            search = search.toLowerCase();
        }

        this.filtereddynamicFormTypeList = this.dynamicFormTypeList.filter(
            (dynamicForm) => dynamicForm['name'].toLowerCase().indexOf(search) > -1
        );
    }

    getAlldynamicForm() {
        this.filtereddynamicFormTypeList = this.dynamicFormTypeList;
    }

    getdynamicForm() {
        this.getdynamicFormList();
        this.dynmaicFormYFilter();
        this.getAlldynamicForm();
        this.getAttributeSetDropDown()
        this.attributeSetFilter();
    }

    attributeSetList: any;

    filteredAttributeList: any;


    attributeFilterControl: UntypedFormControl = new UntypedFormControl();

    getAttributeSetDropDown() {
        this.attributeService.getAttributeSetDropDownList(4).subscribe(
            res => {
                this.attributeSetList = res;

                this.filteredAttributeList = this.attributeSetList;

            },
            error => {

            }
        )
    }



    attributeSetFilter() {
        this.attributeFilterControl.valueChanges
            .pipe(takeUntil(this._onDestroy))
            .subscribe(() => {
                this.attributeFilter();
            });
    }


    protected attributeFilter() {
        if (!this.attributeSetList) {
            return;
        }
        // get the search keyword
        let search = this.attributeFilterControl.value;
        if (!search) {
            this.filteredAttributeList = this.attributeSetList.slice();
            return;
        } else {
            search = search.toLowerCase();
        }
        // filter the banks
        this.filteredAttributeList = this.attributeSetList.filter(attributeSetName => attributeSetName['attributeSetName'].toLowerCase().indexOf(search) > -1)
    }


    openEditorText(value) {

        if (window.innerWidth > 768) {

            const dialogRef = this.dialog.open(TextEditorComponent, {
                width: '900px',
                disableClose: true,
                data: value
            });

            dialogRef.afterClosed().subscribe(result => {
                if (result['event'] == 'add') {
                }


            });

        }
        else {
            const dialogRef = this.dialog.open(TextEditorComponent, {
                minWidth: '100vw', height: '100vh',
                disableClose: true,
                data: value
            });

            dialogRef.afterClosed().subscribe(result => {
                if (result['event'] == 'add') {

                }

            });

        }
    }


    //deliveryPeople

    deliveryPeopleList: any = [];
    deliveryPeopleTypeList: any = [];
    filtereddeliveryPeopleTypeList: any = [];
    deliveryPeopleControl: UntypedFormControl = new UntypedFormControl();
    deliveryPeopleFilterControl: UntypedFormControl = new UntypedFormControl();



    getAllDeliveryPeopleList() {


        this.usersService.getAllUserStatusDropDown().subscribe(
            data => {
                this.deliveryPeopleList = data;
                this.deliveryPeopleTypeList = data;
                this.filtereddeliveryPeopleTypeList = this.deliveryPeopleTypeList;

            }
        )



        this.deliveryYFilter();
        this.getAlldeliveryPeople();
    }


    getAlldeliveryPeople() {
        this.filtereddeliveryPeopleTypeList = this.deliveryPeopleTypeList;
    }

    deliveryYFilter() {
        this.deliveryPeopleFilterControl.valueChanges
            .pipe(takeUntil(this._onDestroy))
            .subscribe(() => {
                this.deliveryFilter();
            });
    }

    protected deliveryFilter() {
        if (!this.deliveryPeopleTypeList) {
            return;
        }
        // get the search keyword
        let search = this.deliveryPeopleFilterControl.value;
        if (!search) {
            this.filtereddeliveryPeopleTypeList = this.deliveryPeopleTypeList.slice();
            return;
        } else {
            search = search.toLowerCase();
        }
        // filter the banks
        this.filtereddeliveryPeopleTypeList = this.deliveryPeopleTypeList.filter(DeliveryPeople => DeliveryPeople['email'].toLowerCase().indexOf(search) > -1)
    }


    //accset 


    accessTypeList: any;
    filteredAccessTypeList: any;
    getAccessList() {

        this.accessSetService.getAccessSetDropDown().subscribe(
            res => {
                this.accessList = res;

                this.accessTypeList = res;
                this.filteredAccessTypeList = this.accessTypeList;
            },
            error => {
            })
    }

    public accessFilterControl: UntypedFormControl = new UntypedFormControl();
    AccessYFilter() {
        this.accessFilterControl.valueChanges
            .pipe(takeUntil(this._onDestroy))
            .subscribe(() => {
                this.accessFilter();
            });
    }


    protected accessFilter() {
        if (!this.accessTypeList) {
            return;
        }
        let search = this.accessFilterControl.value;
        if (!search) {
            this.filteredAccessTypeList = this.accessTypeList.slice();
            return;
        } else {
            search = search.toLowerCase();
        }
        this.filteredAccessTypeList = this.accessTypeList.filter(acccess => acccess['name'].toLowerCase().indexOf(search) > -1)
    }

    getAllAccessSet() {
        this.filteredAccessTypeList = this.accessTypeList;
    }

    listOfAccessSets: any = [];
    onClose() {
        console.log('Dialog closed');
    }
    setLayout(value: string) {
        this.firstFormGroup.get('adminLayout')?.setValue(value);
    }


    copyInputUrl(value) {



        this.clipboard.copy(`${value}`);



    }
    goToNext() {

        this.display = false;
    }

    backWard() {

        this.display = true;
    }


    navigateUrl(url) {
        window.open(url, '_blank');
    }



    sanitizeUrl(u: string): string {
        return (u || '')
            .replace(/^\/+/, '')
            .replace(/[?#&=]/g, '-')
            .replace(/[^a-zA-Z0-9_-]+/g, '-')
            .replace(/-+/g, '-')
            .replace(/^-|-$/g, '')
            .toLowerCase();
    }
}
